import QRP from '../QRP.env';

let fallbackData = {};

fallbackData = {
  userData: {
    productAccess: [
      QRP.PRODUCTS.AUTO,
      QRP.PRODUCTS.HOME,
      QRP.PRODUCTS.CONDO,
      QRP.PRODUCTS.RENTERS,
      QRP.PRODUCTS.HA_BUNDLE,
      QRP.PRODUCTS.CA_BUNDLE,
      QRP.PRODUCTS.RA_BUNDLE,
    ],
  },
  empty: {
    columns: {},
    rows: {},
    Carriers: {},
    States: {},
    Agents: {},
    Teams: {},
    summary: {},
  },
  agentActivityTable: {
    type: 'table',
    id: '1002',
    label: 'Agent Activity Table',
    columns: {
      quote_id: 'Quote ID',
      quote_status: 'Quote Status',
      created_data: 'Created Date',
      updated_date: 'Updated Date',
      carrier_name: 'Carrier Name',
      rc1_premium: 'RC1 Premium',
      term: 'Term',
      final_premium: 'Final Premium',
      policy_number: 'Policy Number',
      effective_date: 'Effective Date',
      email: 'Email',
      agent: 'Agent',
      state: 'State',
    },
    rows: [
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 13:29:18',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 16:23:54',
        carrier_name: 'Progressive',
        rc1_premium: 1423,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 17:06:42',
        carrier_name: 'Progressive',
        rc1_premium: 1379,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 17:19:34',
        carrier_name: 'Progressive',
        rc1_premium: 1409,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 17:19:34',
        carrier_name: 'Bristol West',
        rc1_premium: 1817.64,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{02e835ea-8d15-4419-acda-2eb3f04b73e0}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:29:18',
        updated_date: '2019-03-11 13:30:46',
        carrier_name: 'Progressive',
        rc1_premium: 1379,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi2@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{14469864-a875-4bd9-86c8-a16e5ff43bad}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 12:19:50',
        updated_date: '2019-01-25 12:19:50',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: '',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2379c88f-0841-4814-a6a0-8572035ac7b8}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 10:51:18',
        updated_date: '2019-03-08 10:51:18',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testla30@gmail.com',
        agent: 'Simon Smith',
        state: 'LA',
      },
      {
        quote_id: '{2379c88f-0841-4814-a6a0-8572035ac7b8}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:51:18',
        updated_date: '2019-03-08 10:53:10',
        carrier_name: 'Progressive',
        rc1_premium: 1479,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testla30@gmail.com',
        agent: 'Simon Smith',
        state: 'LA',
      },
      {
        quote_id: '{27618b00-d384-461f-badc-e06d488eb06d}',
        quote_status: 'Completed',
        created_data: '2019-01-16 9:57:37',
        updated_date: '2019-01-16 10:00:52',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547661482830@quinstreet.com',
        agent: 'simon smith',
        state: 'RI',
      },
      {
        quote_id: '{27618b00-d384-461f-badc-e06d488eb06d}',
        quote_status: 'Initiated',
        created_data: '2019-01-16 9:57:37',
        updated_date: '2019-01-16 9:57:37',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547661482830@quinstreet.com',
        agent: 'simon smith',
        state: 'RI',
      },
      {
        quote_id: '{27ca53d9-991f-4104-812f-d7227277b5dc}',
        quote_status: 'Initiated',
        created_data: '2019-03-04 13:19:14',
        updated_date: '2019-03-04 13:19:14',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{27ca53d9-991f-4104-812f-d7227277b5dc}',
        quote_status: 'Completed',
        created_data: '2019-03-04 13:19:14',
        updated_date: '2019-03-04 15:52:15',
        carrier_name: 'Progressive',
        rc1_premium: 991,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{27ca53d9-991f-4104-812f-d7227277b5dc}',
        quote_status: 'Completed',
        created_data: '2019-03-04 13:19:14',
        updated_date: '2019-03-04 13:21:02',
        carrier_name: 'Progressive',
        rc1_premium: 938,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Initiated',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 8:25:14',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 9:53:04',
        carrier_name: 'Progressive',
        rc1_premium: 919.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 9:53:04',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 8:39:25',
        carrier_name: 'Progressive',
        rc1_premium: 985.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 8:39:25',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 12:43:07',
        carrier_name: 'Progressive',
        rc1_premium: 919.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 12:43:07',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 16:58:36',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 16:58:36',
        carrier_name: 'Dairyland',
        rc1_premium: 2813.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 16:58:36',
        carrier_name: 'Bristol West',
        rc1_premium: 898.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-11 9:56:10',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-11 9:56:10',
        carrier_name: 'Dairyland',
        rc1_premium: 2744.16,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-11 9:56:10',
        carrier_name: 'Stillwater',
        rc1_premium: 842.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 14:50:12',
        carrier_name: 'Infinity',
        rc1_premium: 1784.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 14:50:12',
        carrier_name: 'Dairyland',
        rc1_premium: 2744.16,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-03-12 14:50:12',
        carrier_name: 'Stillwater',
        rc1_premium: 842.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 8:54:09',
        carrier_name: 'Progressive',
        rc1_premium: 942.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 9:54:09',
        carrier_name: 'Progressive',
        rc1_premium: 942.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 9:57:26',
        carrier_name: 'Progressive',
        rc1_premium: 942.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 11:13:29',
        carrier_name: 'Progressive',
        rc1_premium: 942.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{282794ec-fd07-4fa0-82c7-919e00b99145}',
        quote_status: 'Completed',
        created_data: '2019-02-08 8:25:14',
        updated_date: '2019-02-08 12:43:43',
        carrier_name: 'Progressive',
        rc1_premium: 942.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549643127838@quinstreet.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-08 11:09:46',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-12 16:42:21',
        carrier_name: 'Progressive',
        rc1_premium: 1346,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-12 16:42:21',
        carrier_name: 'Infinity',
        rc1_premium: 3489,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-12 16:42:21',
        carrier_name: 'Bristol West',
        rc1_premium: 1957,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-12 16:42:21',
        carrier_name: 'The General',
        rc1_premium: 4925.4,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-08 11:14:48',
        carrier_name: 'Progressive',
        rc1_premium: 1366,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 16:33:45',
        carrier_name: 'Progressive',
        rc1_premium: 1506,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 16:33:45',
        carrier_name: 'Bristol West',
        rc1_premium: 1873,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 16:14:47',
        carrier_name: 'Progressive',
        rc1_premium: 1346,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 16:14:47',
        carrier_name: 'Bristol West',
        rc1_premium: 1957,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 13:23:28',
        carrier_name: 'Progressive',
        rc1_premium: 1506,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 13:23:28',
        carrier_name: 'Bristol West',
        rc1_premium: 1873,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 11:37:48',
        carrier_name: 'Progressive',
        rc1_premium: 1508,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 11:53:29',
        carrier_name: 'Progressive',
        rc1_premium: 1366,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29a19c10-c24f-4554-b4a8-688bb5169fc1}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:09:46',
        updated_date: '2019-03-11 11:53:29',
        carrier_name: 'Bristol West',
        rc1_premium: 1674,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testfl3@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{29aa506d-6d63-4275-97ca-43a6008ff06f}',
        quote_status: 'Completed',
        created_data: '2008-01-23 11:21:38',
        updated_date: '2019-02-27 13:19:23',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tebryant@comkt.com',
        agent: 'Simon Credo',
        state: 'CT',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-23 14:54:07',
        carrier_name: 'Progressive',
        rc1_premium: 999,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-23 16:07:02',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-23 16:10:54',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-23 16:11:23',
        carrier_name: 'Progressive',
        rc1_premium: 588,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-23 16:12:55',
        carrier_name: 'Progressive',
        rc1_premium: 588,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 9:21:23',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-25 9:16:45',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-25 11:15:54',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-25 11:26:20',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-24 15:09:48',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-24 11:39:53',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-24 11:23:07',
        carrier_name: 'Progressive',
        rc1_premium: 588,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-24 11:19:25',
        carrier_name: 'Progressive',
        rc1_premium: 588,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-24 9:41:37',
        carrier_name: 'Progressive',
        rc1_premium: 588,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:30:35',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:30:35',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:35:51',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:35:51',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:37:10',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 14:37:10',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 12:40:17',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 12:40:17',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 13:38:40',
        carrier_name: 'Progressive',
        rc1_premium: 655,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-01-28 13:38:40',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-05 8:57:57',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 14:17:54',
        carrier_name: 'Progressive',
        rc1_premium: 615,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 14:17:54',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 15:58:16',
        carrier_name: 'Progressive',
        rc1_premium: 618,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 16:43:28',
        carrier_name: 'Safeco',
        rc1_premium: 1699.56,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 16:32:37',
        carrier_name: 'Progressive',
        rc1_premium: 618,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 18:43:10',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 18:44:46',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-28 2:49:40',
        carrier_name: 'Progressive',
        rc1_premium: 1158,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-28 2:51:42',
        carrier_name: 'Progressive',
        rc1_premium: 1158,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-26 22:13:03',
        carrier_name: 'Progressive',
        rc1_premium: 1158,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-26 22:19:12',
        carrier_name: 'Progressive',
        rc1_premium: 1158,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-25 2:13:43',
        carrier_name: 'Progressive',
        rc1_premium: 1158,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-25 2:09:29',
        carrier_name: 'Progressive',
        rc1_premium: 976,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-26 15:25:49',
        carrier_name: 'Progressive',
        rc1_premium: 881,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-27 1:59:17',
        carrier_name: 'Progressive',
        rc1_premium: 881,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-28 2:45:40',
        carrier_name: 'Progressive',
        rc1_premium: 881,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-15 9:36:08',
        carrier_name: 'Progressive',
        rc1_premium: 618,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-13 14:08:56',
        carrier_name: 'Progressive',
        rc1_premium: 618,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-21 10:38:20',
        carrier_name: 'Progressive',
        rc1_premium: 976,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-21 10:33:51',
        carrier_name: 'Progressive',
        rc1_premium: 713,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-19 10:59:22',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-13 14:10:24',
        carrier_name: 'Progressive',
        rc1_premium: 802,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 16:34:41',
        carrier_name: 'Progressive',
        rc1_premium: 802,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 17:15:14',
        carrier_name: 'Progressive',
        rc1_premium: 802,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 17:16:18',
        carrier_name: 'Progressive',
        rc1_premium: 802,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-12 18:44:35',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-15 9:36:33',
        carrier_name: 'Progressive',
        rc1_premium: 802,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 14:24:39',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2a117095-5c5a-4815-b04e-55295f9516b8}',
        quote_status: 'Completed',
        created_data: '2019-01-11 15:01:47',
        updated_date: '2019-02-04 14:44:51',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonny@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Purchased',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-07 10:18:43',
        carrier_name: 'Progressive',
        rc1_premium: 'NULL',
        term: '6Month',
        final_premium: 1202,
        policy_number: 800907329,
        effective_date: '2019-03-12 0:00:00',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Initiated',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-04 15:59:25',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 12:13:54',
        carrier_name: 'Progressive',
        rc1_premium: 1025,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 13:39:01',
        carrier_name: 'Progressive',
        rc1_premium: 1113,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 13:43:27',
        carrier_name: 'Progressive',
        rc1_premium: 1202,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 13:43:27',
        carrier_name: 'Bristol West',
        rc1_premium: 1164,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-04 16:01:21',
        carrier_name: 'Progressive',
        rc1_premium: 1339,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-07 10:16:14',
        carrier_name: 'Progressive',
        rc1_premium: 1202,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-07 10:16:14',
        carrier_name: 'Bristol West',
        rc1_premium: 1164,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 16:50:23',
        carrier_name: 'Progressive',
        rc1_premium: 1202,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-07 10:17:13',
        carrier_name: 'Progressive',
        rc1_premium: 1202,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 13:44:45',
        carrier_name: 'Progressive',
        rc1_premium: 1202,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-04 16:05:00',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2b204262-a9b2-4f7b-845f-9c81f0621b0b}',
        quote_status: 'Completed',
        created_data: '2019-03-04 15:59:25',
        updated_date: '2019-03-06 13:42:17',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tflorida@gmail.com',
        agent: 'Simon Smith',
        state: 'FL',
      },
      {
        quote_id: '{2da5b094-78aa-4662-8107-293795667564}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 14:03:16',
        updated_date: '2019-03-11 14:03:16',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test.devwi@gmail.com',
        agent: 'Simon Smith',
        state: 'WI',
      },
      {
        quote_id: '{2da5b094-78aa-4662-8107-293795667564}',
        quote_status: 'Completed',
        created_data: '2019-03-11 14:03:16',
        updated_date: '2019-03-11 16:10:36',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test.devwi@gmail.com',
        agent: 'Simon Smith',
        state: 'WI',
      },
      {
        quote_id: '{2da5b094-78aa-4662-8107-293795667564}',
        quote_status: 'Completed',
        created_data: '2019-03-11 14:03:16',
        updated_date: '2019-03-11 14:04:56',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test.devwi@gmail.com',
        agent: 'Simon Smith',
        state: 'WI',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Initiated',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:33:24',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Completed',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:36:14',
        carrier_name: 'Progressive',
        rc1_premium: 2186,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Completed',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:36:14',
        carrier_name: 'Plymouth Rock',
        rc1_premium: 921,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Completed',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:36:14',
        carrier_name: 'Bristol West',
        rc1_premium: 5605,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Completed',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:40:36',
        carrier_name: 'Plymouth Rock',
        rc1_premium: 956,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2ee53bb1-ae10-42a0-af5c-6c0b589f4bba}',
        quote_status: 'Completed',
        created_data: '2019-03-12 16:33:24',
        updated_date: '2019-03-12 16:40:36',
        carrier_name: 'Bristol West',
        rc1_premium: 3091,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'simonsmt@test.com',
        agent: 'simon smith',
        state: 'NJ',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 10:37:58',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-14 14:28:43',
        carrier_name: 'Progressive',
        rc1_premium: 744,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-14 14:28:43',
        carrier_name: 'Safeco',
        rc1_premium: 2347.1,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-14 14:28:43',
        carrier_name: 'Bristol West',
        rc1_premium: 1051,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 10:41:49',
        carrier_name: 'Progressive',
        rc1_premium: 826,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 10:41:49',
        carrier_name: 'Bristol West',
        rc1_premium: 1227,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 10:39:28',
        carrier_name: 'Bristol West',
        rc1_premium: 2235,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 14:06:02',
        carrier_name: 'Progressive',
        rc1_premium: 828,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-08 14:06:02',
        carrier_name: 'Bristol West',
        rc1_premium: 1227,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-12 14:54:01',
        carrier_name: 'Progressive',
        rc1_premium: 744,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-12 14:54:01',
        carrier_name: 'Bristol West',
        rc1_premium: 1051,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-11 12:31:25',
        carrier_name: 'Progressive',
        rc1_premium: 744,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-11 12:31:25',
        carrier_name: 'Bristol West',
        rc1_premium: 1051,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{2f34c2a4-069c-4985-b434-944135620e1e}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:37:57',
        updated_date: '2019-03-11 10:03:41',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testil@gmail.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{41dc97d0-5091-403c-80f4-ed2b0b65e2d1}',
        quote_status: 'Initiated',
        created_data: '2019-03-04 14:55:44',
        updated_date: '2019-03-04 14:55:44',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tmichigan@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{41dc97d0-5091-403c-80f4-ed2b0b65e2d1}',
        quote_status: 'Completed',
        created_data: '2019-03-04 14:55:44',
        updated_date: '2019-03-04 14:57:07',
        carrier_name: 'Progressive',
        rc1_premium: 1464,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tmichigan@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-11 13:48:03',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-11 13:49:54',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-11 13:52:45',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-11 16:37:45',
        carrier_name: 'Bristol West',
        rc1_premium: 2799,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:46:18',
        carrier_name: 'Progressive',
        rc1_premium: 2389,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:46:18',
        carrier_name: 'Plymouth Rock',
        rc1_premium: 708,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:46:18',
        carrier_name: 'Bristol West',
        rc1_premium: 5296,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:47:58',
        carrier_name: 'Progressive',
        rc1_premium: 2389,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:47:58',
        carrier_name: 'Plymouth Rock',
        rc1_premium: 708,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-13 9:47:58',
        carrier_name: 'Bristol West',
        rc1_premium: 5296,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-12 16:23:37',
        carrier_name: 'Progressive',
        rc1_premium: 2389,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-12 16:23:37',
        carrier_name: 'Plymouth Rock',
        rc1_premium: 708,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{42142a28-2920-4bba-a798-af768266719e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:48:03',
        updated_date: '2019-03-12 16:23:37',
        carrier_name: 'Bristol West',
        rc1_premium: 5296,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testnj@gmail.com',
        agent: 'Simon Smith',
        state: 'NJ',
      },
      {
        quote_id: '{4bb31559-4617-4c77-b227-980809ff4ee5}',
        quote_status: 'Initiated',
        created_data: '2019-03-05 11:07:19',
        updated_date: '2019-03-05 11:07:19',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testct@gmail.com',
        agent: 'Simon Smith',
        state: 'CT',
      },
      {
        quote_id: '{4bb31559-4617-4c77-b227-980809ff4ee5}',
        quote_status: 'Completed',
        created_data: '2019-03-05 11:07:19',
        updated_date: '2019-03-05 11:08:48',
        carrier_name: 'Progressive',
        rc1_premium: 896,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testct@gmail.com',
        agent: 'Simon Smith',
        state: 'CT',
      },
      {
        quote_id: '{4bb31559-4617-4c77-b227-980809ff4ee5}',
        quote_status: 'Completed',
        created_data: '2019-03-05 11:07:19',
        updated_date: '2019-03-05 17:05:59',
        carrier_name: 'Progressive',
        rc1_premium: 1024,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testct@gmail.com',
        agent: 'Simon Smith',
        state: 'CT',
      },
      {
        quote_id: '{4bb31559-4617-4c77-b227-980809ff4ee5}',
        quote_status: 'Completed',
        created_data: '2019-03-05 11:07:19',
        updated_date: '2019-03-05 17:14:50',
        carrier_name: 'Progressive',
        rc1_premium: 1014,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testct@gmail.com',
        agent: 'Simon Smith',
        state: 'CT',
      },
      {
        quote_id: '{4ef4b4f1-3c66-490a-b3b9-0f30a22e0de7}',
        quote_status: 'Initiated',
        created_data: '2019-03-04 9:20:17',
        updated_date: '2019-03-04 9:20:17',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{4ef4b4f1-3c66-490a-b3b9-0f30a22e0de7}',
        quote_status: 'Completed',
        created_data: '2019-03-04 9:20:17',
        updated_date: '2019-03-04 9:22:13',
        carrier_name: 'Progressive',
        rc1_premium: 938,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{5db514bb-abc6-47ae-9367-772a7daab81d}',
        quote_status: 'Initiated',
        created_data: '2019-03-01 11:40:19',
        updated_date: '2019-03-01 11:40:19',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tebryant@comkt.com',
        agent: 'Simon Credo',
        state: 'CT',
      },
      {
        quote_id: '{5db514bb-abc6-47ae-9367-772a7daab81d}',
        quote_status: 'Completed',
        created_data: '2019-03-01 11:40:19',
        updated_date: '2019-03-01 11:52:23',
        carrier_name: 'Progressive',
        rc1_premium: 784,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tebryant@comkt.com',
        agent: 'Simon Credo',
        state: 'CT',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 11:15:00',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 11:15:00',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4523.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 11:15:00',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:54:50',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4523.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:54:50',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:56:11',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4523.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:56:11',
        carrier_name: 'Arrowhead',
        rc1_premium: 3116,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:52:43',
        carrier_name: 'Progressive',
        rc1_premium: 1944,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:52:43',
        carrier_name: 'Arrowhead',
        rc1_premium: 2745,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:22:50',
        carrier_name: 'Progressive',
        rc1_premium: 1603,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:26:17',
        carrier_name: 'Progressive',
        rc1_premium: 1801,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:26:17',
        carrier_name: 'Arrowhead',
        rc1_premium: 3072.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:26:17',
        carrier_name: 'Bristol West',
        rc1_premium: 5305,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-07 1:09:10',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:25:16',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:03:45',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-17 3:21:15',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:51:55',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 10:51:58',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 12:00:56',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-01-23 12:00:59',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Initiated',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-03 23:53:02',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-07 1:10:19',
        carrier_name: 'Progressive',
        rc1_premium: 1721,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-07 1:10:19',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4641,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-07 1:10:19',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:04:33',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:04:33',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4523.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:04:33',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:25:53',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:25:53',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4523.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-02-06 1:25:53',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 1:15:50',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 1:15:50',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4713.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 1:15:50',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 1:15:50',
        carrier_name: 'Bristol West',
        rc1_premium: 5638.62,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:48:04',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:48:04',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4713.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:48:04',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-03 23:55:16',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-03 23:55:16',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4713.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-03 23:55:16',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:03:33',
        carrier_name: 'Progressive',
        rc1_premium: 1775,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:03:33',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4713.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:03:33',
        carrier_name: 'Arrowhead',
        rc1_premium: 3127.01,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 0:03:33',
        carrier_name: 'Bristol West',
        rc1_premium: 5638.62,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7274a27d-9ae7-4559-aa02-1f7e1ae3aa80}',
        quote_status: 'Completed',
        created_data: '2019-01-17 3:21:15',
        updated_date: '2019-03-04 9:09:11',
        carrier_name: 'Progressive',
        rc1_premium: 938,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmi@gmail.com',
        agent: 'Simon Smith',
        state: 'MI',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 3:45:32',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 21:31:34',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-17 23:05:34',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:17:08',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 22:57:36',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 1:35:08',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:04:34',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Initiated',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 4:00:48',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 23:04:22',
        carrier_name: 'Progressive',
        rc1_premium: 996.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 21:37:42',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:28:40',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 1:41:21',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:29:29',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:32:14',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 3:46:08',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:21:35',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:21:35',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:19:24',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 1:19:24',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 21:32:09',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-18 21:32:09',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-17 23:08:17',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-17 23:21:30',
        carrier_name: 'Progressive',
        rc1_premium: 1074.17,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-17 23:21:30',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3684.24,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 1:37:43',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 1:37:43',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:15:27',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:15:27',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:06:43',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 2:06:43',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 4:02:52',
        carrier_name: 'Progressive',
        rc1_premium: 230.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-15 4:02:52',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 3130.8,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 23:00:07',
        carrier_name: 'Progressive',
        rc1_premium: 712.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 23:00:07',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4029.84,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 23:00:58',
        carrier_name: 'Progressive',
        rc1_premium: 712.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-14 23:00:58',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 4029.84,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-26 14:27:14',
        carrier_name: 'Progressive',
        rc1_premium: 711.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-26 14:30:36',
        carrier_name: 'Progressive',
        rc1_premium: 711.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{7bf59151-b5ae-4f93-90cf-cf2e665a5550}',
        quote_status: 'Completed',
        created_data: '2019-02-14 22:57:36',
        updated_date: '2019-02-26 14:34:16',
        carrier_name: 'Progressive',
        rc1_premium: 711.3,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'johnson@gmail.com',
        agent: 'Simon Johnson',
        state: 'NC',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:07:11',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:34:06',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:08:51',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:08:54',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:23:24',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Safeco',
        rc1_premium: 413.9,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Dairyland',
        rc1_premium: 696.13,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Safe Auto',
        rc1_premium: 420,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 1809.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'Bristol West',
        rc1_premium: 262,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:25:44',
        carrier_name: 'First Chicago',
        rc1_premium: 314.99,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Safeco',
        rc1_premium: 413.9,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Dairyland',
        rc1_premium: 696.13,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Safe Auto',
        rc1_premium: 420,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 1956,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'Bristol West',
        rc1_premium: 276,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:47:55',
        carrier_name: 'First Chicago',
        rc1_premium: 314.99,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:46:58',
        carrier_name: 'Progressive',
        rc1_premium: 160,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-01-25 13:51:29',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'MetLife',
        rc1_premium: 271.98,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'Dairyland',
        rc1_premium: 747.75,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'Safe Auto',
        rc1_premium: 420,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 1968.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'Mercury',
        rc1_premium: 1246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:20:19',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'MetLife',
        rc1_premium: 271.98,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'Dairyland',
        rc1_premium: 747.75,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 1968.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'Mercury',
        rc1_premium: 1246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:13:24',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 3:58:05',
        carrier_name: 'Progressive',
        rc1_premium: 246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 3:58:05',
        carrier_name: 'Dairyland',
        rc1_premium: 765.82,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 3:58:05',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 3:58:05',
        carrier_name: 'Mercury',
        rc1_premium: 417,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 3:58:05',
        carrier_name: 'The General',
        rc1_premium: 550.24,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:51:15',
        carrier_name: 'Progressive',
        rc1_premium: 246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:51:15',
        carrier_name: 'Dairyland',
        rc1_premium: 765.82,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:51:15',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:51:15',
        carrier_name: 'Mercury',
        rc1_premium: 1246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:51:15',
        carrier_name: 'The General',
        rc1_premium: 550.24,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'MetLife',
        rc1_premium: 271.98,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'Dairyland',
        rc1_premium: 747.75,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'Safe Auto',
        rc1_premium: 420,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'Mercury',
        rc1_premium: 1246,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-25 2:28:44',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'Progressive',
        rc1_premium: 504,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'Dairyland',
        rc1_premium: 2155.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'Mercury',
        rc1_premium: 1332,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'The General',
        rc1_premium: 1420.16,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:10:04',
        carrier_name: 'Elephant',
        rc1_premium: 1917.98,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'Progressive',
        rc1_premium: 504,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'Dairyland',
        rc1_premium: 2155.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'Mercury',
        rc1_premium: 1332,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'The General',
        rc1_premium: 1420.16,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-03-01 1:25:43',
        carrier_name: 'Elephant',
        rc1_premium: 1917.98,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:35:18',
        carrier_name: 'Progressive',
        rc1_premium: 504,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:35:18',
        carrier_name: 'Dairyland',
        rc1_premium: 2155.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:35:18',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2360.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:35:18',
        carrier_name: 'The General',
        rc1_premium: 1420.16,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:35:18',
        carrier_name: 'Elephant',
        rc1_premium: 1874.03,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Progressive',
        rc1_premium: 554,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Travelers',
        rc1_premium: 1189.68,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Dairyland',
        rc1_premium: 2292.94,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2558.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Mercury',
        rc1_premium: 1380,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'The General',
        rc1_premium: 1510.12,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 14:48:35',
        carrier_name: 'Elephant',
        rc1_premium: 1975.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Progressive',
        rc1_premium: 554,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Travelers',
        rc1_premium: 1189.68,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Dairyland',
        rc1_premium: 2292.94,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 2558.04,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Mercury',
        rc1_premium: 1380,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'The General',
        rc1_premium: 1510.12,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{838a7f5b-ed65-4edb-b865-9d8294732f7f}',
        quote_status: 'Completed',
        created_data: '2019-01-25 13:23:24',
        updated_date: '2019-02-27 22:31:34',
        carrier_name: 'Elephant',
        rc1_premium: 1987.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil2@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{8e3a2f76-d569-4516-9761-1f7cc47613a8}',
        quote_status: 'Completed',
        created_data: '2018-09-23 18:56:21',
        updated_date: '2019-02-22 9:15:16',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1537754254336@quinstreet.com',
        agent: 'Simon Lars',
        state: 'FL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-08 11:26:33',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-11 11:34:10',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-11 13:27:09',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-11 16:07:29',
        carrier_name: 'Good2Go',
        rc1_premium: 1726.93,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-08 11:28:00',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{916f06bf-f8ef-4956-9d47-5d0d36266612}',
        quote_status: 'Completed',
        created_data: '2019-03-08 11:26:33',
        updated_date: '2019-03-08 11:29:26',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9c9a5892-cc7e-40df-8b09-8104516343ba}',
        quote_status: 'Completed',
        created_data: '2019-01-04 10:56:25',
        updated_date: '2019-03-15 14:06:32',
        carrier_name: 'Progressive',
        rc1_premium: 472.59,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'qrpwv@email.com',
        agent: 'Simon Francis',
        state: 'WV',
      },
      {
        quote_id: '{9c9a5892-cc7e-40df-8b09-8104516343ba}',
        quote_status: 'Completed',
        created_data: '2019-01-04 10:56:25',
        updated_date: '2019-03-15 14:06:32',
        carrier_name: 'Safeco',
        rc1_premium: 1155.62,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'qrpwv@email.com',
        agent: 'Simon Francis',
        state: 'WV',
      },
      {
        quote_id: '{9c9a5892-cc7e-40df-8b09-8104516343ba}',
        quote_status: 'Completed',
        created_data: '2019-01-04 10:56:25',
        updated_date: '2019-03-12 14:14:02',
        carrier_name: 'Progressive',
        rc1_premium: 314.72,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'qrpwv@email.com',
        agent: 'Simon Francis',
        state: 'WV',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-08 10:11:56',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-12 16:50:23',
        carrier_name: 'Progressive',
        rc1_premium: 869,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-14 12:03:05',
        carrier_name: 'Progressive',
        rc1_premium: 831,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-14 12:03:05',
        carrier_name: 'Safeco',
        rc1_premium: 2954.1,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-08 10:20:13',
        carrier_name: 'Progressive',
        rc1_premium: 1019,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9d61ebc8-9980-4371-9ee8-6916aff57944}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:11:56',
        updated_date: '2019-03-08 10:20:13',
        carrier_name: 'Bristol West',
        rc1_premium: 4152,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testar@gmail.com',
        agent: 'Simon Smith',
        state: 'AR',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-08 9:08:59',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-08 10:01:44',
        carrier_name: 'Progressive',
        rc1_premium: 854,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-08 10:09:05',
        carrier_name: 'Progressive',
        rc1_premium: 978,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-11 12:06:00',
        carrier_name: 'Progressive',
        rc1_premium: 1059,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-14 11:31:14',
        carrier_name: 'Progressive',
        rc1_premium: 1021,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-14 11:31:14',
        carrier_name: 'Safeco',
        rc1_premium: 3050.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{9df8e4c2-52ed-426b-857f-5616d410fd44}',
        quote_status: 'Completed',
        created_data: '2019-03-08 9:08:59',
        updated_date: '2019-03-12 16:40:19',
        carrier_name: 'Progressive',
        rc1_premium: 1059,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testal@gmail.com',
        agent: 'Simon Smith',
        state: 'AL',
      },
      {
        quote_id: '{a541abd0-1265-4885-9d9f-711115f657ff}',
        quote_status: 'Initiated',
        created_data: '2019-03-01 14:44:36',
        updated_date: '2019-03-01 14:44:36',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tebryant@comkt.com',
        agent: 'Simon Credo',
        state: 'CT',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Initiated',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 15:51:32',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:52:06',
        carrier_name: 'Progressive',
        rc1_premium: 1233.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:52:06',
        carrier_name: 'Infinity',
        rc1_premium: 2354,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:52:06',
        carrier_name: 'Bristol West',
        rc1_premium: 6692,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:52:06',
        carrier_name: 'National General',
        rc1_premium: 5386.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:01:34',
        carrier_name: 'Progressive',
        rc1_premium: 1189.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:01:34',
        carrier_name: 'Infinity',
        rc1_premium: 2068,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:01:34',
        carrier_name: 'Bristol West',
        rc1_premium: 5874,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:01:34',
        carrier_name: 'National General',
        rc1_premium: 5276.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:03:41',
        carrier_name: 'Progressive',
        rc1_premium: 1090.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:03:41',
        carrier_name: 'Infinity',
        rc1_premium: 1929,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:03:41',
        carrier_name: 'Bristol West',
        rc1_premium: 5542,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:03:41',
        carrier_name: 'National General',
        rc1_premium: 4860.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:25:29',
        carrier_name: 'Progressive',
        rc1_premium: 1160.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:25:29',
        carrier_name: 'Infinity',
        rc1_premium: 2022,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:25:29',
        carrier_name: 'Bristol West',
        rc1_premium: 5961,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:25:29',
        carrier_name: 'National General',
        rc1_premium: 5030.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:29:23',
        carrier_name: 'Progressive',
        rc1_premium: 1226.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:29:23',
        carrier_name: 'Infinity',
        rc1_premium: 2322,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:29:23',
        carrier_name: 'Bristol West',
        rc1_premium: 6662,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:29:23',
        carrier_name: 'National General',
        rc1_premium: 5351.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 15:53:13',
        carrier_name: 'Infinity',
        rc1_premium: 1773,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 15:55:30',
        carrier_name: 'Progressive',
        rc1_premium: 1153.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 15:55:30',
        carrier_name: 'Infinity',
        rc1_premium: 1757,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 15:55:30',
        carrier_name: 'Bristol West',
        rc1_premium: 5708,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:08:26',
        carrier_name: 'Progressive',
        rc1_premium: 1515.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:08:26',
        carrier_name: 'Infinity',
        rc1_premium: 2391,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:08:26',
        carrier_name: 'Bristol West',
        rc1_premium: 7124,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:08:26',
        carrier_name: 'National General',
        rc1_premium: 5740.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:11:45',
        carrier_name: 'Progressive',
        rc1_premium: 1566.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:11:45',
        carrier_name: 'Infinity',
        rc1_premium: 2434,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:11:45',
        carrier_name: 'Bristol West',
        rc1_premium: 7610,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:11:45',
        carrier_name: 'National General',
        rc1_premium: 5937.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:13:47',
        carrier_name: 'Progressive',
        rc1_premium: 1500.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:13:47',
        carrier_name: 'Infinity',
        rc1_premium: 2134,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:13:47',
        carrier_name: 'Bristol West',
        rc1_premium: 6909,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:13:47',
        carrier_name: 'National General',
        rc1_premium: 5616.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:54:34',
        carrier_name: 'Progressive',
        rc1_premium: 1226.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:54:34',
        carrier_name: 'Infinity',
        rc1_premium: 2322,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:54:34',
        carrier_name: 'Bristol West',
        rc1_premium: 6662,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:54:34',
        carrier_name: 'National General',
        rc1_premium: 5351.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:59:13',
        carrier_name: 'Progressive',
        rc1_premium: 1389.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:59:13',
        carrier_name: 'Infinity',
        rc1_premium: 2402,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:59:13',
        carrier_name: 'Bristol West',
        rc1_premium: 7580,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 16:59:13',
        carrier_name: 'National General',
        rc1_premium: 5902.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:02:33',
        carrier_name: 'Progressive',
        rc1_premium: 1338.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:02:33',
        carrier_name: 'Infinity',
        rc1_premium: 2359,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:02:33',
        carrier_name: 'Bristol West',
        rc1_premium: 7094,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:02:33',
        carrier_name: 'National General',
        rc1_premium: 5705.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:04:49',
        carrier_name: 'Progressive',
        rc1_premium: 1508.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:04:49',
        carrier_name: 'Infinity',
        rc1_premium: 2359,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:04:49',
        carrier_name: 'Bristol West',
        rc1_premium: 7094,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-07 17:04:49',
        carrier_name: 'National General',
        rc1_premium: 5705.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 8:50:34',
        carrier_name: 'Progressive',
        rc1_premium: 1500.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 8:50:34',
        carrier_name: 'Infinity',
        rc1_premium: 2134,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 8:50:34',
        carrier_name: 'National General',
        rc1_premium: 5616.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 9:06:04',
        carrier_name: 'Progressive',
        rc1_premium: 1916.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 9:06:04',
        carrier_name: 'Infinity',
        rc1_premium: 2493,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-08 9:06:04',
        carrier_name: 'Bristol West',
        rc1_premium: 4731,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:57:09',
        carrier_name: 'Progressive',
        rc1_premium: 1652.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:57:09',
        carrier_name: 'Infinity',
        rc1_premium: 2238,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:57:09',
        carrier_name: 'Bristol West',
        rc1_premium: 1177,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:23:33',
        carrier_name: 'Progressive',
        rc1_premium: 1623.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:15:12',
        carrier_name: 'Progressive',
        rc1_premium: 1845.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:15:12',
        carrier_name: 'Infinity',
        rc1_premium: 2381,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:15:12',
        carrier_name: 'Stillwater',
        rc1_premium: 1302,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:15:12',
        carrier_name: 'Bristol West',
        rc1_premium: 2723,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:15:12',
        carrier_name: 'National General',
        rc1_premium: 3204.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:16:46',
        carrier_name: 'Progressive',
        rc1_premium: 1648.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:16:46',
        carrier_name: 'Infinity',
        rc1_premium: 2101,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:16:46',
        carrier_name: 'Stillwater',
        rc1_premium: 1235,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:16:46',
        carrier_name: 'Bristol West',
        rc1_premium: 2434,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 11:16:46',
        carrier_name: 'National General',
        rc1_premium: 2809.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:06:07',
        carrier_name: 'Infinity',
        rc1_premium: 2493,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:06:07',
        carrier_name: 'Bristol West',
        rc1_premium: 4731,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:06:07',
        carrier_name: 'National General',
        rc1_premium: 6031.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:09:04',
        carrier_name: 'Infinity',
        rc1_premium: 2009,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:09:04',
        carrier_name: 'Stillwater',
        rc1_premium: 1249,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:09:04',
        carrier_name: 'Bristol West',
        rc1_premium: 2457,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a7418412-cb4a-48be-a19f-ce035704a636}',
        quote_status: 'Completed',
        created_data: '2019-03-07 15:51:32',
        updated_date: '2019-03-11 10:09:04',
        carrier_name: 'National General',
        rc1_premium: 3028.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmetroaz@gmail.com',
        agent: 'Simon Smith',
        state: 'AZ',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-11 10:48:07',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Completed',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-11 10:57:51',
        carrier_name: 'Progressive',
        rc1_premium: 306.42,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Completed',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-11 11:12:34',
        carrier_name: 'Progressive',
        rc1_premium: 355.28,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Completed',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-14 14:41:42',
        carrier_name: 'Progressive',
        rc1_premium: 377.68,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Completed',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-14 14:41:42',
        carrier_name: 'Safeco',
        rc1_premium: 1416.34,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a761ea7e-e093-4f96-8ef0-3491f7ea94e6}',
        quote_status: 'Completed',
        created_data: '2019-03-11 10:48:07',
        updated_date: '2019-03-14 14:41:42',
        carrier_name: 'Bristol West',
        rc1_premium: 808.73,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test123@gmail.com',
        agent: 'Simon Smith',
        state: 'KY',
      },
      {
        quote_id: '{a83d61ec-5043-4684-903c-c05fc4b3f54e}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 13:56:34',
        updated_date: '2019-03-11 13:56:34',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'safeauto@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{a83d61ec-5043-4684-903c-c05fc4b3f54e}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:56:34',
        updated_date: '2019-03-11 14:01:05',
        carrier_name: 'Progressive',
        rc1_premium: 880,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'safeauto@test.com',
        agent: 'Simon Smith',
        state: 'NY',
      },
      {
        quote_id: '{c16c7709-4d5a-4504-8d28-aa808d8227a7}',
        quote_status: 'Initiated',
        created_data: '2019-03-11 13:43:09',
        updated_date: '2019-03-11 13:43:09',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'safeauto@test.com',
        agent: 'Simon Smith',
        state: 'NC',
      },
      {
        quote_id: '{c16c7709-4d5a-4504-8d28-aa808d8227a7}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:43:09',
        updated_date: '2019-03-11 16:35:24',
        carrier_name: 'Progressive',
        rc1_premium: 614.84,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'safeauto@test.com',
        agent: 'Simon Smith',
        state: 'NC',
      },
      {
        quote_id: '{c16c7709-4d5a-4504-8d28-aa808d8227a7}',
        quote_status: 'Completed',
        created_data: '2019-03-11 13:43:09',
        updated_date: '2019-03-11 13:45:39',
        carrier_name: 'Progressive',
        rc1_premium: 623.84,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'safeauto@test.com',
        agent: 'Simon Smith',
        state: 'NC',
      },
      {
        quote_id: '{c2665aeb-f742-4e4f-99c2-57876c255f49}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 10:22:13',
        updated_date: '2019-03-08 10:22:13',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmo@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{c2665aeb-f742-4e4f-99c2-57876c255f49}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:22:13',
        updated_date: '2019-03-08 10:25:52',
        carrier_name: 'Progressive',
        rc1_premium: 965.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmo@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{c2665aeb-f742-4e4f-99c2-57876c255f49}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:22:13',
        updated_date: '2019-03-08 10:25:52',
        carrier_name: 'Infinity',
        rc1_premium: 3318.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmo@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{c2665aeb-f742-4e4f-99c2-57876c255f49}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:22:13',
        updated_date: '2019-03-08 10:25:52',
        carrier_name: 'Dairyland',
        rc1_premium: 5302.68,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmo@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{c2665aeb-f742-4e4f-99c2-57876c255f49}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:22:13',
        updated_date: '2019-03-08 10:25:52',
        carrier_name: 'National General',
        rc1_premium: 2699.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testmo@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Initiated',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-08 15:21:45',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Completed',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-08 15:26:43',
        carrier_name: 'Progressive',
        rc1_premium: 1170,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Completed',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-26 15:31:59',
        carrier_name: 'Progressive',
        rc1_premium: 1171,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Completed',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-26 17:03:22',
        carrier_name: 'Progressive',
        rc1_premium: 891,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Completed',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-26 16:13:03',
        carrier_name: 'Progressive',
        rc1_premium: 891,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c47ad000-eb73-4c70-b216-60e3589b47a4}',
        quote_status: 'Completed',
        created_data: '2019-02-08 15:21:45',
        updated_date: '2019-02-26 15:35:20',
        carrier_name: 'Progressive',
        rc1_premium: 891,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1549668118928@quinstreet.com',
        agent: 'simon smith',
        state: 'CT',
      },
      {
        quote_id: '{c79a6872-2e0d-4227-ba7a-8cbfa62a5365}',
        quote_status: 'Purchased',
        created_data: '2019-03-07 14:46:12',
        updated_date: '2019-03-07 15:08:04',
        carrier_name: 'Progressive',
        rc1_premium: 'NULL',
        term: '6Month',
        final_premium: 1675,
        policy_number: 800907373,
        effective_date: '2019-03-07 0:00:00',
        email: 'smithpa@gmail.com',
        agent: 'Simon Smith',
        state: 'PA',
      },
      {
        quote_id: '{c79a6872-2e0d-4227-ba7a-8cbfa62a5365}',
        quote_status: 'Initiated',
        created_data: '2019-03-07 14:46:12',
        updated_date: '2019-03-07 14:46:12',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'smithpa@gmail.com',
        agent: 'Simon Smith',
        state: 'PA',
      },
      {
        quote_id: '{c79a6872-2e0d-4227-ba7a-8cbfa62a5365}',
        quote_status: 'Completed',
        created_data: '2019-03-07 14:46:12',
        updated_date: '2019-03-07 14:59:25',
        carrier_name: 'Progressive',
        rc1_premium: 1740,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'smithpa@gmail.com',
        agent: 'Simon Smith',
        state: 'PA',
      },
      {
        quote_id: '{c79a6872-2e0d-4227-ba7a-8cbfa62a5365}',
        quote_status: 'Completed',
        created_data: '2019-03-07 14:46:12',
        updated_date: '2019-03-07 15:02:06',
        carrier_name: 'Progressive',
        rc1_premium: 1675,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'smithpa@gmail.com',
        agent: 'Simon Smith',
        state: 'PA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Initiated',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:32:56',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Initiated',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:33:03',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Progressive',
        rc1_premium: 968.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Infinity',
        rc1_premium: 2063.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Dairyland',
        rc1_premium: 4123.48,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'GMAC',
        rc1_premium: 2052.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Arrowhead',
        rc1_premium: 858.25,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Safeway',
        rc1_premium: 1217.87,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Mercury',
        rc1_premium: 775.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-11 1:34:36',
        carrier_name: 'Clearcover',
        rc1_premium: 780.9,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-26 15:10:02',
        carrier_name: 'Progressive',
        rc1_premium: 1501.88,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-26 15:10:02',
        carrier_name: 'Infinity',
        rc1_premium: 2664.76,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{cc91194d-d858-4c37-bf00-d7cf1fd1e4b6}',
        quote_status: 'Completed',
        created_data: '2019-02-11 1:32:56',
        updated_date: '2019-02-26 15:10:02',
        carrier_name: 'Safeway',
        rc1_premium: 1577.87,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'test@gmail.com',
        agent: 'Simon Smith',
        state: 'CA',
      },
      {
        quote_id: '{d23a1e42-75f5-41f7-b082-7f9a01707d22}',
        quote_status: 'Initiated',
        created_data: '2019-03-08 10:33:49',
        updated_date: '2019-03-08 10:33:49',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testco@gmail.com',
        agent: 'Simon Smith',
        state: 'CO',
      },
      {
        quote_id: '{d23a1e42-75f5-41f7-b082-7f9a01707d22}',
        quote_status: 'Completed',
        created_data: '2019-03-08 10:33:49',
        updated_date: '2019-03-08 10:35:14',
        carrier_name: 'Progressive',
        rc1_premium: 1834.5,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'testco@gmail.com',
        agent: 'Simon Smith',
        state: 'CO',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'Progressive',
        rc1_premium: 176,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'Safeco',
        rc1_premium: 413.9,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'Safe Auto',
        rc1_premium: 420,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'Liberty Mutual',
        rc1_premium: 1809.96,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'Bristol West',
        rc1_premium: 262,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Completed',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:28:13',
        carrier_name: 'The General',
        rc1_premium: 518.2,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{dee54edc-5f9c-46a1-b2f6-d79551c46ec4}',
        quote_status: 'Initiated',
        created_data: '2019-01-25 11:25:06',
        updated_date: '2019-01-25 11:25:06',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'lfil@email.com',
        agent: 'Simon Smith',
        state: 'IL',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Purchased',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-02-13 15:22:35',
        carrier_name: 'Progressive',
        rc1_premium: 'NULL',
        term: '12Month',
        final_premium: 7263,
        policy_number: 800903987,
        effective_date: '2019-02-23 0:00:00',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 13:49:29',
        carrier_name: 'Progressive',
        rc1_premium: 3386,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 14:39:21',
        carrier_name: 'Progressive',
        rc1_premium: 3386,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 14:41:03',
        carrier_name: 'Progressive',
        rc1_premium: 3386,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 13:54:20',
        carrier_name: 'Progressive',
        rc1_premium: 3386,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:48:36',
        carrier_name: 'Progressive',
        rc1_premium: 3386,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:51:30',
        carrier_name: 'Progressive',
        rc1_premium: 3168,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:57:13',
        carrier_name: 'Progressive',
        rc1_premium: 3130,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-28 13:00:55',
        carrier_name: 'Progressive',
        rc1_premium: 3567,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-28 13:03:54',
        carrier_name: 'Progressive',
        rc1_premium: 4080,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-15 14:38:26',
        carrier_name: 'Progressive',
        rc1_premium: 3908,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-15 15:29:12',
        carrier_name: 'Progressive',
        rc1_premium: 2527,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-15 9:20:26',
        carrier_name: 'Progressive',
        rc1_premium: 3908,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-16 8:49:23',
        carrier_name: 'Progressive',
        rc1_premium: 2527,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-16 11:13:08',
        carrier_name: 'Progressive',
        rc1_premium: 2527,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-02-13 15:09:02',
        carrier_name: 'Progressive',
        rc1_premium: 4395,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-02-13 15:11:08',
        carrier_name: 'Progressive',
        rc1_premium: 3833,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:50:39',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:55:59',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:59:06',
        carrier_name: 'Progressive',
        rc1_premium: 6524,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 16:08:35',
        carrier_name: 'Progressive',
        rc1_premium: 5925,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 14:59:52',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 15:00:42',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 13:52:06',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 13:57:49',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-01-25 13:57:56',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{f3f5423a-dd37-44bc-91c5-71f250c59cd6}',
        quote_status: 'Completed',
        created_data: '2019-01-11 11:07:52',
        updated_date: '2019-02-13 15:13:30',
        carrier_name: 'Progressive',
        rc1_premium: 7263,
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'quote1547233687338@quinstreet.com',
        agent: 'simon smith',
        state: 'MI',
      },
      {
        quote_id: '{fa90050e-946c-474c-952f-2fb96cd9bf23}',
        quote_status: 'Initiated',
        created_data: '2019-03-01 14:51:00',
        updated_date: '2019-03-01 14:51:00',
        carrier_name: 'NULL',
        rc1_premium: 'NULL',
        term: 'NULL',
        final_premium: 'NULL',
        policy_number: 'NULL',
        effective_date: 'NULL',
        email: 'tebryant@comkt.com',
        agent: 'Simon Credo',
        state: 'CT',
      },
    ],
    title: 'Agent Activity',
  },
  userActivity: {
    label: '# of Policies by Agent',
    labels: [
      'red-bull@example.com',
      'blue-dog@example.com',
      'yeller-beller@example.com',
      'mr-green@example.com',
      'purple-rain@example.com',
      'agent-oragne@example.com',
    ],
    metrics: [
      5,
      1,
      3,
      12,
      2,
      3,
    ],
  },
  carrierActivity:  {
    label: '$ of Premiums Sold',
    labels: [
      'Carrier Albatross',
      'Carrier Banky',
      'Carrier Cow',
    ],
    metrics: [
      8000,
      4000,
      1000,
    ],
  },
  agencyActivity: {
    labels: ['1/1', '1/2', '1/3', '1/4', '1/5', '1/6', '1/7', '1/8', '1/9', '1/10', '1/11', '1/12'],
    datasets: [
      {
        label: 'Agency ONE',
        backgroundColor: '#f87900',
        data: [12, 15, 12, 33, 1, 12, 14, 12, 10, 5, 12, 21],
      }, {
        label: 'Agency TWO',
        backgroundColor: '#f87979',
        data: [40, 20, 12, 39, 10, 40, 39, 37, 40, 20, 12, 37],
      },
    ],
  },
  userActivityTable: {
    type: 'table',
    id: '1001',
    label: 'User Activity Table',
    columns: {
      time: 'Time',
      quote_id: 'Quote ID',
      agent_name: 'Agent Name',
      location: 'Geo-location',
      carrier_name: 'Carrier',
      quote_status: 'Quote Status',
      quote_premium: 'Quote Premium',
    },
    rows: [
      {
        time: '18 Feb 2019',
        quote_id: '{a9122713-803e-4430-b4ef-2379f86ebea3}',
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '18 Feb 2019',
        quote_id: '{a9898767-803e-4430-b4ef-2379f86ebed2}',
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 550,
      },
      {
        time: '18 Feb 2019',
        quote_id: '{a7797997-803e-4430-b4ef-2379f86alax2}',
        agent_name: 'johndoe@email.com',
        location: 'NY',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 912,
      },
      {
        time: '19 Feb 2019',
        quote_id: 1891,
        agent_name: 'slothymcslother@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '19 Feb 2019',
        quote_id: '{K8769971-803e-4430-b4ef-2379f86fhsa2}',
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 290,
      },
      {
        time: '19 Feb 2019',
        quote_id: '{Z4449971-803e-4430-b4ef-2379f86fh222}',
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 880,
      },
      {
        time: '19 Feb 2019',
        quote_id: '{Z5559971-803e-4430-b4ef-2379f86fh555}',
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 590,
      },
      {
        time: '19 Feb 2019',
        quote_id: '{a7772713-803e-4430-b4ef-2379f86eb777}',
        agent_name: 'johndoe@email.com',
        location: 'TX',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 770,
      },
      {
        time: '19 Feb 2019',
        quote_id: '{a3332713-803e-4a30-b4ef-2379f86eb333}',
        agent_name: 'slothymcslother@email.com',
        location: 'CA',
        carrier_name: 'Acme Co',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '19 Feb 2019',
        quote_id: 1856,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 990,
      },
      {
        time: '19 Feb 2019',
        quote_id: 1243,
        agent_name: 'slothymcslother@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 580,
      },
      {
        time: '19 Feb 2019',
        quote_id: 1618,
        agent_name: 'johndoe@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 290,
      },
      {
        time: '19 Feb 2019',
        quote_id: 1671,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '20 Feb 2019',
        quote_id: 1859,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '20 Feb 2019',
        quote_id: 1953,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '20 Feb 2019',
        quote_id: 1774,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '20 Feb 2019',
        quote_id: 1050,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 330,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1694,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 290,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1612,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 190,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1116,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 980,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1113,
        agent_name: 'slothymcslother@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 580,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1074,
        agent_name: 'johndoe@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '21 Feb 2019',
        quote_id: 1488,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1061,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1986,
        agent_name: 'johndoe@email.com',
        location: 'TX',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1139,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1664,
        agent_name: 'zoeyoli@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1943,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 230,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1368,
        agent_name: 'slothymcslother@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 240,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1518,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 235,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1769,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 290,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1387,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 220,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1241,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 215,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1270,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 700,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1767,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Completed',
        quote_premium: 970,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1177,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1480,
        agent_name: 'zoeyoli@email.com',
        location: 'NY',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1149,
        agent_name: 'slothymcslother@email.com',
        location: 'NY',
        carrier_name: 'Acme Co',
        quote_status: 'Quote Completed',
        quote_premium: 210,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1756,
        agent_name: 'slothymcslother@email.com',
        location: 'NJ',
        carrier_name: 'Acme Co',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1009,
        agent_name: 'slothymcslother@email.com',
        location: 'NY',
        carrier_name: 'King Cobra',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1436,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1951,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1880,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1276,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1105,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Completed',
        quote_premium: 240,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1989,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1667,
        agent_name: 'johndoe@email.com',
        location: 'CA',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1035,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Dairyland',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
      {
        time: '22 Feb 2019',
        quote_id: 1737,
        agent_name: 'zoeyoli@email.com',
        location: 'TX',
        carrier_name: 'Progressive',
        quote_status: 'Quote Initiated',
        quote_premium: 0,
      },
    ],
    title: 'Agent Activity',
  },
  activityTable: {
    type: 'table',
    id: '1002',
    label: 'Carrier Activity Table 2',
    columns: {
      CarrierName: 'Carrier Name',
      State: 'State',
      login_name: 'Login Name',
      CustomerCount: 'Customer Count',
      PolicyCount: 'Policy Count',
      RateCallCount: 'Rate Call Count',
      RateCallSuccess: 'Rate Call Success',
      RateCallError: 'Rate Call Error',
      AvgRateCallPremium: 'Avg Rate Call Premium',
      AvgPolicyPremium: 'Avg Policy Premium',
    },
    rows: [
      {
        CarrierName: '21st Century Insurance',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 175,
        RateCallError: 210,
        AvgRateCallPremium: 1142.188571,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 0,
        RateCallError: 539,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 0,
        RateCallError: 77,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 0,
        RateCallError: 129,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: '21st Century Insurance',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 247,
        RateCallError: 35,
        AvgRateCallPremium: 1822.380526,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 174,
        RateCallError: 211,
        AvgRateCallPremium: 1204.058092,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 217,
        RateCallError: 25,
        AvgRateCallPremium: 5775.887465,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 114,
        RateCallError: 15,
        AvgRateCallPremium: 3006.568859,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 3667.01,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Arrowhead',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AL',
        login_name: 'janedoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AL',
        login_name: 'johndoe@email.com',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 1,
        RateCallError: 13,
        AvgRateCallPremium: 1249,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 104,
        RateCallError: 49,
        AvgRateCallPremium: 4601.125,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AR',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 6,
        RateCallError: 3,
        AvgRateCallPremium: 4072,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 73,
        PolicyCount: 0,
        RateCallCount: 73,
        RateCallSuccess: 34,
        RateCallError: 39,
        AvgRateCallPremium: 3985.67647,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 53,
        RateCallError: 332,
        AvgRateCallPremium: 1892.049811,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 171,
        PolicyCount: 1,
        RateCallCount: 170,
        RateCallSuccess: 28,
        RateCallError: 142,
        AvgRateCallPremium: 1092.536071,
        AvgPolicyPremium: 3000,
      },
      {
        CarrierName: 'Bristol West',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 13,
        RateCallError: 36,
        AvgRateCallPremium: 1680.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CO',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 12,
        RateCallError: 12,
        AvgRateCallPremium: 3661.583333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CO',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 3438.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 17,
        RateCallError: 90,
        AvgRateCallPremium: 5570.529411,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 34,
        RateCallError: 90,
        AvgRateCallPremium: 3831.735294,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'FL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 59,
        PolicyCount: 0,
        RateCallCount: 59,
        RateCallSuccess: 20,
        RateCallError: 39,
        AvgRateCallPremium: 1411.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 32,
        RateCallError: 507,
        AvgRateCallPremium: 1283.21875,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 23,
        RateCallError: 12,
        AvgRateCallPremium: 1744.521739,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 382,
        PolicyCount: 0,
        RateCallCount: 382,
        RateCallSuccess: 150,
        RateCallError: 232,
        AvgRateCallPremium: 2824.393333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'FL',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 22,
        RateCallError: 220,
        AvgRateCallPremium: 3281.136363,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'GA',
        login_name: 'johndoe@email.com',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 3,
        RateCallError: 26,
        AvgRateCallPremium: 2484,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 0,
        RateCallError: 16,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 31,
        RateCallError: 88,
        AvgRateCallPremium: 1692.225806,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 43,
        PolicyCount: 0,
        RateCallCount: 43,
        RateCallSuccess: 23,
        RateCallError: 20,
        AvgRateCallPremium: 1350.260869,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 6,
        RateCallError: 11,
        AvgRateCallPremium: 2092.833333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 1,
        RateCallError: 28,
        AvgRateCallPremium: 1532,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'KS',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 21,
        RateCallError: 56,
        AvgRateCallPremium: 1504.217142,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'KY',
        login_name: 'johndoe@email.com',
        CustomerCount: 63,
        PolicyCount: 0,
        RateCallCount: 63,
        RateCallSuccess: 4,
        RateCallError: 59,
        AvgRateCallPremium: 3127.8275,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'LA',
        login_name: 'johndoe@email.com',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MD',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'ME',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MI',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 35,
        RateCallError: 94,
        AvgRateCallPremium: 4535.608571,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MI',
        login_name: 'janedoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 2,
        RateCallError: 7,
        AvgRateCallPremium: 5070.64,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 228,
        PolicyCount: 0,
        RateCallCount: 228,
        RateCallSuccess: 26,
        RateCallError: 202,
        AvgRateCallPremium: 6461.433846,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 10,
        RateCallError: 58,
        AvgRateCallPremium: 3022.35,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MN',
        login_name: 'janedoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MN',
        login_name: 'johndoe@email.com',
        CustomerCount: 33,
        PolicyCount: 0,
        RateCallCount: 33,
        RateCallSuccess: 10,
        RateCallError: 23,
        AvgRateCallPremium: 2386.7,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 3,
        RateCallError: 20,
        AvgRateCallPremium: 4141,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MO',
        login_name: 'johndoe@email.com',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 3,
        RateCallError: 24,
        AvgRateCallPremium: 7813.666666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 42,
        RateCallError: 26,
        AvgRateCallPremium: 1553.190476,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 4,
        RateCallError: 6,
        AvgRateCallPremium: 2886,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'MT',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'ND',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NE',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NH',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NJ',
        login_name: 'janedoe@email.com',
        CustomerCount: 32,
        PolicyCount: 0,
        RateCallCount: 32,
        RateCallSuccess: 23,
        RateCallError: 9,
        AvgRateCallPremium: 3020.434782,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NJ',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 2,
        RateCallError: 3,
        AvgRateCallPremium: 3249.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NV',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 0,
        RateCallError: 7,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NY',
        login_name: 'janedoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'NY',
        login_name: 'johndoe@email.com',
        CustomerCount: 215,
        PolicyCount: 1,
        RateCallCount: 214,
        RateCallSuccess: 11,
        RateCallError: 203,
        AvgRateCallPremium: 3560.272727,
        AvgPolicyPremium: 123.45,
      },
      {
        CarrierName: 'Bristol West',
        State: 'NY',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 0,
        RateCallError: 26,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 1,
        RateCallError: 5,
        AvgRateCallPremium: 2751,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 11,
        RateCallError: 20,
        AvgRateCallPremium: 1687.818181,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 54,
        RateCallError: 53,
        AvgRateCallPremium: 2994.722222,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 9,
        RateCallError: 8,
        AvgRateCallPremium: 3724.671111,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OK',
        login_name: 'johndoe@email.com',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 3,
        RateCallError: 2,
        AvgRateCallPremium: 1324.666666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 1,
        RateCallError: 101,
        AvgRateCallPremium: 2793,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 7,
        RateCallError: 19,
        AvgRateCallPremium: 1091.857142,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'SC',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'SD',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 2908,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 3506,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 5,
        RateCallError: 119,
        AvgRateCallPremium: 1532.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 7,
        RateCallError: 27,
        AvgRateCallPremium: 1167.857142,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'UT',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 1631,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 7,
        RateCallError: 20,
        AvgRateCallPremium: 1562.142857,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'VA',
        login_name: 'johndoe@email.com',
        CustomerCount: 36,
        PolicyCount: 0,
        RateCallCount: 36,
        RateCallSuccess: 4,
        RateCallError: 32,
        AvgRateCallPremium: 2468.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 3,
        RateCallError: 2,
        AvgRateCallPremium: 1637.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 6,
        RateCallError: 20,
        AvgRateCallPremium: 6657.166666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 3,
        RateCallError: 3,
        AvgRateCallPremium: 1967,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WI',
        login_name: 'janedoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WI',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 2,
        RateCallError: 22,
        AvgRateCallPremium: 2785,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Bristol West',
        State: 'WY',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Clearcover',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 212,
        RateCallError: 173,
        AvgRateCallPremium: 862.749764,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Clearcover',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 0,
        RateCallError: 153,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'AR',
        login_name: 'johndoe@email.com',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 73,
        PolicyCount: 0,
        RateCallCount: 73,
        RateCallSuccess: 0,
        RateCallError: 73,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 223,
        RateCallError: 162,
        AvgRateCallPremium: 4793.562286,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 171,
        PolicyCount: 1,
        RateCallCount: 170,
        RateCallSuccess: 26,
        RateCallError: 144,
        AvgRateCallPremium: 4129.096923,
        AvgPolicyPremium: 45454.55,
      },
      {
        CarrierName: 'Dairyland',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 21,
        RateCallError: 28,
        AvgRateCallPremium: 1368.241428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'CO',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 1,
        RateCallError: 23,
        AvgRateCallPremium: 482.96,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'CO',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 73,
        PolicyCount: 0,
        RateCallCount: 73,
        RateCallSuccess: 0,
        RateCallError: 73,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'DE',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'FL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 59,
        PolicyCount: 0,
        RateCallCount: 59,
        RateCallSuccess: 0,
        RateCallError: 59,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 303,
        RateCallError: 236,
        AvgRateCallPremium: 3140.927491,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 0,
        RateCallError: 35,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 382,
        PolicyCount: 0,
        RateCallCount: 382,
        RateCallSuccess: 10,
        RateCallError: 372,
        AvgRateCallPremium: 4430.16,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'FL',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 22,
        RateCallError: 24,
        AvgRateCallPremium: 1885.488636,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'IA',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 0,
        RateCallError: 14,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'ID',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 1,
        RateCallError: 15,
        AvgRateCallPremium: 2722.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 47,
        RateCallError: 72,
        AvgRateCallPremium: 1291.700851,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 44,
        PolicyCount: 1,
        RateCallCount: 43,
        RateCallSuccess: 9,
        RateCallError: 34,
        AvgRateCallPremium: 2015.244444,
        AvgPolicyPremium: 3348.95,
      },
      {
        CarrierName: 'Dairyland',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'KS',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'LA',
        login_name: 'johndoe@email.com',
        CustomerCount: 52,
        PolicyCount: 0,
        RateCallCount: 52,
        RateCallSuccess: 0,
        RateCallError: 52,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MD',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MI',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 252,
        PolicyCount: 0,
        RateCallCount: 252,
        RateCallSuccess: 0,
        RateCallError: 252,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MO',
        login_name: 'johndoe@email.com',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 22,
        RateCallError: 12,
        AvgRateCallPremium: 3109.39,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 15,
        RateCallError: 40,
        AvgRateCallPremium: 961.290666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NC',
        login_name: 'janedoe@email.com',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 85,
        PolicyCount: 0,
        RateCallCount: 85,
        RateCallSuccess: 12,
        RateCallError: 73,
        AvgRateCallPremium: 865.4525,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 6,
        RateCallError: 9,
        AvgRateCallPremium: 2225.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NE',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 15,
        RateCallError: 32,
        AvgRateCallPremium: 2725.92,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NM',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'NV',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 6,
        RateCallError: 1,
        AvgRateCallPremium: 663.62,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 1,
        RateCallError: 5,
        AvgRateCallPremium: 1140,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 0,
        RateCallError: 31,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 3,
        RateCallError: 104,
        AvgRateCallPremium: 358,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OK',
        login_name: 'johndoe@email.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 0,
        RateCallError: 16,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 20,
        RateCallError: 82,
        AvgRateCallPremium: 3054.4595,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 25,
        RateCallError: 23,
        AvgRateCallPremium: 3868.0556,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'SC',
        login_name: 'johndoe@email.com',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'SD',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 7,
        RateCallError: 1,
        AvgRateCallPremium: 1394.215714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 55,
        RateCallError: 69,
        AvgRateCallPremium: 1352.85709,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 0,
        RateCallError: 34,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'UT',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 15,
        RateCallError: 12,
        AvgRateCallPremium: 2088.066666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 1,
        RateCallError: 4,
        AvgRateCallPremium: 2293.57,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 0,
        RateCallError: 26,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 1,
        RateCallError: 5,
        AvgRateCallPremium: 1363.86,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'WI',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 1,
        RateCallError: 23,
        AvgRateCallPremium: 1097.76,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Dairyland',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 65,
        PolicyCount: 0,
        RateCallCount: 65,
        RateCallSuccess: 14,
        RateCallError: 51,
        AvgRateCallPremium: 2483.002857,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 266,
        RateCallError: 16,
        AvgRateCallPremium: 965.193984,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 96,
        RateCallError: 57,
        AvgRateCallPremium: 1673.168645,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 514,
        RateCallError: 25,
        AvgRateCallPremium: 2217.392159,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 122,
        RateCallError: 120,
        AvgRateCallPremium: 2509.679426,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 24,
        RateCallError: 44,
        AvgRateCallPremium: 562.3825,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 7,
        RateCallError: 1,
        AvgRateCallPremium: 952.431428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Direct General',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 86,
        RateCallError: 38,
        AvgRateCallPremium: 1812.220813,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 42,
        RateCallError: 77,
        AvgRateCallPremium: 2296.010238,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 1,
        RateCallError: 16,
        AvgRateCallPremium: 1465.99,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 12,
        RateCallError: 49,
        AvgRateCallPremium: 2940.6725,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 1875,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 23,
        RateCallError: 101,
        AvgRateCallPremium: 2694.073913,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Elephant',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 2,
        RateCallError: 25,
        AvgRateCallPremium: 2327.46,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 8,
        RateCallError: 274,
        AvgRateCallPremium: 939.5025,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 47,
        RateCallError: 106,
        AvgRateCallPremium: 2301.132127,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 3,
        RateCallError: 8,
        AvgRateCallPremium: 769.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 384,
        PolicyCount: 0,
        RateCallCount: 384,
        RateCallSuccess: 69,
        RateCallError: 315,
        AvgRateCallPremium: 1511.374927,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 7,
        RateCallError: 42,
        AvgRateCallPremium: 1335.651428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 45,
        RateCallError: 62,
        AvgRateCallPremium: 923.153333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 15,
        RateCallError: 524,
        AvgRateCallPremium: 1241.784,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 88,
        RateCallError: 154,
        AvgRateCallPremium: 1757.341818,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 5,
        RateCallError: 41,
        AvgRateCallPremium: 508.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 5,
        RateCallError: 9,
        AvgRateCallPremium: 543,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 38,
        RateCallError: 81,
        AvgRateCallPremium: 887.439736,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 3,
        RateCallError: 14,
        AvgRateCallPremium: 1667.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 15,
        RateCallError: 62,
        AvgRateCallPremium: 1176.703333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 24,
        RateCallError: 37,
        AvgRateCallPremium: 978.206666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 40,
        RateCallError: 89,
        AvgRateCallPremium: 2253.64675,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 24,
        RateCallError: 44,
        AvgRateCallPremium: 1806.583333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 1,
        RateCallError: 22,
        AvgRateCallPremium: 861,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 4,
        RateCallError: 64,
        AvgRateCallPremium: 1971.3175,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 0,
        RateCallError: 55,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 1,
        RateCallError: 14,
        AvgRateCallPremium: 677,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 4,
        RateCallError: 9,
        AvgRateCallPremium: 1960.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 5,
        RateCallError: 42,
        AvgRateCallPremium: 739.998,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 4,
        RateCallError: 27,
        AvgRateCallPremium: 635.25,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 2,
        RateCallError: 15,
        AvgRateCallPremium: 1068.005,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 5,
        RateCallError: 22,
        AvgRateCallPremium: 1233.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 0,
        RateCallError: 102,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 7,
        RateCallError: 41,
        AvgRateCallPremium: 1135,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'SD',
        login_name: 'consumer',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 743,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 61,
        RateCallError: 63,
        AvgRateCallPremium: 1406.737704,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 7,
        RateCallError: 20,
        AvgRateCallPremium: 1057.285714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 4,
        RateCallError: 1,
        AvgRateCallPremium: 730.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 1,
        RateCallError: 5,
        AvgRateCallPremium: 605,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Esurance',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 65,
        PolicyCount: 0,
        RateCallCount: 65,
        RateCallSuccess: 0,
        RateCallError: 65,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'First Chicago',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 45,
        RateCallError: 74,
        AvgRateCallPremium: 829.538444,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 94,
        RateCallError: 445,
        AvgRateCallPremium: 1121.572978,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 61,
        RateCallError: 181,
        AvgRateCallPremium: 5427.263442,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 8,
        RateCallError: 39,
        AvgRateCallPremium: 1275.50375,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 1,
        RateCallError: 16,
        AvgRateCallPremium: 2972.01,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 31,
        RateCallError: 17,
        AvgRateCallPremium: 1548.236451,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 5,
        RateCallError: 3,
        AvgRateCallPremium: 1198.618,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 32,
        RateCallError: 92,
        AvgRateCallPremium: 2633.733437,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 2,
        RateCallError: 15,
        AvgRateCallPremium: 1313.005,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GainsCo',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 0,
        RateCallError: 282,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 60,
        RateCallError: 325,
        AvgRateCallPremium: 3538.072666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 0,
        RateCallError: 55,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 3,
        RateCallError: 99,
        AvgRateCallPremium: 4411,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'GMAC',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 10,
        RateCallError: 272,
        AvgRateCallPremium: 1644.767,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'AL',
        login_name: 'janedoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 3,
        RateCallError: 2,
        AvgRateCallPremium: 1495.873333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 18,
        RateCallError: 89,
        AvgRateCallPremium: 2090.444444,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 46,
        RateCallError: 196,
        AvgRateCallPremium: 1247,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 0,
        RateCallError: 119,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 10,
        RateCallError: 7,
        AvgRateCallPremium: 2576.9,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 0,
        RateCallError: 29,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 0,
        RateCallError: 68,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'NJ',
        login_name: 'janedoe@email.com',
        CustomerCount: 32,
        PolicyCount: 0,
        RateCallCount: 32,
        RateCallSuccess: 0,
        RateCallError: 32,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 2,
        RateCallError: 100,
        AvgRateCallPremium: 3102.525,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Good2Go',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 0,
        RateCallError: 282,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 0,
        RateCallError: 153,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 1,
        RateCallError: 10,
        AvgRateCallPremium: 1023,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 73,
        PolicyCount: 0,
        RateCallCount: 73,
        RateCallSuccess: 38,
        RateCallError: 35,
        AvgRateCallPremium: 2074.657894,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 206,
        RateCallError: 179,
        AvgRateCallPremium: 4114.95398,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 211,
        PolicyCount: 41,
        RateCallCount: 170,
        RateCallSuccess: 139,
        RateCallError: 31,
        AvgRateCallPremium: 4443.155683,
        AvgPolicyPremium: 1847.496585,
      },
      {
        CarrierName: 'Infinity',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 0,
        RateCallError: 49,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 0,
        RateCallError: 107,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'FL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 59,
        PolicyCount: 0,
        RateCallCount: 59,
        RateCallSuccess: 16,
        RateCallError: 43,
        AvgRateCallPremium: 2599.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 34,
        RateCallError: 505,
        AvgRateCallPremium: 2294.558823,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 3,
        RateCallError: 32,
        AvgRateCallPremium: 4198.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 383,
        PolicyCount: 1,
        RateCallCount: 382,
        RateCallSuccess: 116,
        RateCallError: 266,
        AvgRateCallPremium: 6505.922413,
        AvgPolicyPremium: 890,
      },
      {
        CarrierName: 'Infinity',
        State: 'FL',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 21,
        RateCallError: 221,
        AvgRateCallPremium: 9594.857142,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 0,
        RateCallError: 46,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 0,
        RateCallError: 14,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 0,
        RateCallError: 119,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 0,
        RateCallError: 77,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 0,
        RateCallError: 61,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 0,
        RateCallError: 129,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 0,
        RateCallError: 68,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 0,
        RateCallError: 68,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 0,
        RateCallError: 55,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 0,
        RateCallError: 15,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 0,
        RateCallError: 47,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 0,
        RateCallError: 31,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 0,
        RateCallError: 102,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 0,
        RateCallError: 48,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'SD',
        login_name: 'consumer',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 22,
        RateCallError: 102,
        AvgRateCallPremium: 4770.954545,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 10,
        RateCallError: 24,
        AvgRateCallPremium: 4677.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Infinity',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 65,
        PolicyCount: 0,
        RateCallCount: 65,
        RateCallSuccess: 0,
        RateCallError: 65,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 100,
        RateCallError: 182,
        AvgRateCallPremium: 3625.674,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 45,
        RateCallError: 108,
        AvgRateCallPremium: 3733.485333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 1,
        RateCallError: 10,
        AvgRateCallPremium: 4167.96,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 24,
        RateCallError: 25,
        AvgRateCallPremium: 2871.01,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 12,
        RateCallError: 95,
        AvgRateCallPremium: 3745.26,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 24,
        RateCallError: 515,
        AvgRateCallPremium: 3326.36,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 26,
        RateCallError: 216,
        AvgRateCallPremium: 4126.038461,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 10,
        RateCallError: 36,
        AvgRateCallPremium: 2675.016,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 3,
        RateCallError: 11,
        AvgRateCallPremium: 2063.36,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 33,
        RateCallError: 86,
        AvgRateCallPremium: 2710.018181,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 6,
        RateCallError: 11,
        AvgRateCallPremium: 3541.66,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 30,
        RateCallError: 47,
        AvgRateCallPremium: 3112.524,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 8,
        RateCallError: 53,
        AvgRateCallPremium: 3955.26,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 3,
        RateCallError: 10,
        AvgRateCallPremium: 1929,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 129,
        PolicyCount: 0,
        RateCallCount: 129,
        RateCallSuccess: 38,
        RateCallError: 91,
        AvgRateCallPremium: 4818.508421,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 11,
        RateCallError: 57,
        AvgRateCallPremium: 2751.981818,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 13,
        RateCallError: 10,
        AvgRateCallPremium: 4861.033846,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 7,
        RateCallError: 61,
        AvgRateCallPremium: 4186.731428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 20,
        RateCallError: 35,
        AvgRateCallPremium: 3087.468,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 8,
        RateCallError: 7,
        AvgRateCallPremium: 2883.51,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 2,
        RateCallError: 6,
        AvgRateCallPremium: 2752.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 5,
        RateCallError: 8,
        AvgRateCallPremium: 3126.408,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 30,
        RateCallError: 17,
        AvgRateCallPremium: 3913.792,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 16,
        RateCallError: 5,
        AvgRateCallPremium: 3942.535,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 9,
        RateCallError: 22,
        AvgRateCallPremium: 2226.866666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 3,
        RateCallError: 14,
        AvgRateCallPremium: 4951,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 6,
        RateCallError: 21,
        AvgRateCallPremium: 3318,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 77,
        RateCallError: 25,
        AvgRateCallPremium: 2936.054025,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 7,
        RateCallError: 10,
        AvgRateCallPremium: 2028.685714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 26,
        RateCallError: 22,
        AvgRateCallPremium: 3633.710769,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 2304,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 12,
        RateCallError: 112,
        AvgRateCallPremium: 4329.27,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 2,
        RateCallError: 15,
        AvgRateCallPremium: 2611.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 4,
        RateCallError: 23,
        AvgRateCallPremium: 3870.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 1,
        RateCallError: 4,
        AvgRateCallPremium: 3102.96,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 1,
        RateCallError: 5,
        AvgRateCallPremium: 2942.04,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Liberty Mutual',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 65,
        PolicyCount: 0,
        RateCallCount: 65,
        RateCallSuccess: 49,
        RateCallError: 16,
        AvgRateCallPremium: 3293.434285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 5,
        RateCallError: 6,
        AvgRateCallPremium: 3119.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 387,
        PolicyCount: 0,
        RateCallCount: 387,
        RateCallSuccess: 201,
        RateCallError: 186,
        AvgRateCallPremium: 1058.221105,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 500,
        RateCallError: 39,
        AvgRateCallPremium: 2369.84,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 188,
        RateCallError: 54,
        AvgRateCallPremium: 2421.867021,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 35,
        RateCallError: 84,
        AvgRateCallPremium: 1255.571428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 4,
        RateCallError: 13,
        AvgRateCallPremium: 2240.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 56,
        RateCallError: 68,
        AvgRateCallPremium: 1403.696428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Mercury',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 5,
        RateCallError: 22,
        AvgRateCallPremium: 2304.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 0,
        RateCallError: 282,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 0,
        RateCallError: 153,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 0,
        RateCallError: 49,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 8,
        RateCallError: 99,
        AvgRateCallPremium: 1073.1075,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 0,
        RateCallError: 242,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 3,
        RateCallError: 43,
        AvgRateCallPremium: 1260.98,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 0,
        RateCallError: 14,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 36,
        RateCallError: 83,
        AvgRateCallPremium: 660.665,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 1,
        RateCallError: 16,
        AvgRateCallPremium: 696,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 4,
        RateCallError: 73,
        AvgRateCallPremium: 696,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 1,
        RateCallError: 60,
        AvgRateCallPremium: 696,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 0,
        RateCallError: 68,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 0,
        RateCallError: 15,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 19,
        RateCallError: 28,
        AvgRateCallPremium: 688.367368,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 0,
        RateCallError: 31,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 0,
        RateCallError: 27,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 0,
        RateCallError: 48,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'SD',
        login_name: 'consumer',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 0,
        RateCallError: 124,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 7,
        RateCallError: 20,
        AvgRateCallPremium: 696,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'MetLife',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 4,
        RateCallError: 7,
        AvgRateCallPremium: 1283.21,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 126,
        RateCallError: 259,
        AvgRateCallPremium: 850.401507,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 38,
        RateCallError: 81,
        AvgRateCallPremium: 886.533684,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 9,
        RateCallError: 18,
        AvgRateCallPremium: 1433.173333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 32,
        RateCallError: 70,
        AvgRateCallPremium: 1445.1825,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 8,
        RateCallError: 19,
        AvgRateCallPremium: 940.5125,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Metromile',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 773.53,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'AL',
        login_name: 'johndoe@email.com',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 19,
        RateCallError: 16,
        AvgRateCallPremium: 4816.447368,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 56,
        PolicyCount: 1,
        RateCallCount: 55,
        RateCallSuccess: 19,
        RateCallError: 36,
        AvgRateCallPremium: 3183.431578,
        AvgPolicyPremium: 123.45,
      },
      {
        CarrierName: 'National General',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 54,
        PolicyCount: 0,
        RateCallCount: 54,
        RateCallSuccess: 0,
        RateCallError: 54,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 0,
        RateCallError: 49,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 0,
        RateCallError: 16,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'LA',
        login_name: 'johndoe@email.com',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'MN',
        login_name: 'johndoe@email.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 2,
        RateCallError: 15,
        AvgRateCallPremium: 1345.665,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'NH',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'NJ',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'NY',
        login_name: 'johndoe@email.com',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 1,
        RateCallError: 22,
        AvgRateCallPremium: 7399,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'NY',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 55,
        PolicyCount: 0,
        RateCallCount: 55,
        RateCallSuccess: 5,
        RateCallError: 50,
        AvgRateCallPremium: 5602.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'RI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 0,
        RateCallError: 10,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'VA',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 2035,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'WI',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'National General',
        State: 'WV',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Plymouth Rock',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 34,
        RateCallError: 73,
        AvgRateCallPremium: 861,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Plymouth Rock',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Plymouth Rock',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 11,
        RateCallError: 2,
        AvgRateCallPremium: 1028.90909,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Plymouth Rock',
        State: 'NJ',
        login_name: 'janedoe@email.com',
        CustomerCount: 30,
        PolicyCount: 0,
        RateCallCount: 30,
        RateCallSuccess: 25,
        RateCallError: 5,
        AvgRateCallPremium: 857.32,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Plymouth Rock',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 19,
        RateCallError: 83,
        AvgRateCallPremium: 677.789473,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 47,
        RateCallError: 235,
        AvgRateCallPremium: 662.74468,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AL',
        login_name: 'johndoe@email.com',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 13,
        RateCallError: 2,
        AvgRateCallPremium: 870.692307,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 95,
        RateCallError: 58,
        AvgRateCallPremium: 1182.473684,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AR',
        login_name: 'johndoe@email.com',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 11,
        RateCallError: 2,
        AvgRateCallPremium: 957.545454,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 12,
        PolicyCount: 0,
        RateCallCount: 12,
        RateCallSuccess: 5,
        RateCallError: 7,
        AvgRateCallPremium: 800.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 92,
        PolicyCount: 1,
        RateCallCount: 91,
        RateCallSuccess: 80,
        RateCallError: 11,
        AvgRateCallPremium: 1152.930769,
        AvgPolicyPremium: 704.5,
      },
      {
        CarrierName: 'Progressive',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 433,
        PolicyCount: 0,
        RateCallCount: 433,
        RateCallSuccess: 366,
        RateCallError: 67,
        AvgRateCallPremium: 1081.075301,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 297,
        PolicyCount: 14,
        RateCallCount: 283,
        RateCallSuccess: 171,
        RateCallError: 112,
        AvgRateCallPremium: 981.255862,
        AvgPolicyPremium: 773.842142,
      },
      {
        CarrierName: 'Progressive',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 60,
        PolicyCount: 1,
        RateCallCount: 59,
        RateCallSuccess: 42,
        RateCallError: 17,
        AvgRateCallPremium: 907.21875,
        AvgPolicyPremium: 363.5,
      },
      {
        CarrierName: 'Progressive',
        State: 'CO',
        login_name: 'johndoe@email.com',
        CustomerCount: 43,
        PolicyCount: 1,
        RateCallCount: 42,
        RateCallSuccess: 39,
        RateCallError: 3,
        AvgRateCallPremium: 1374.145833,
        AvgPolicyPremium: 845.5,
      },
      {
        CarrierName: 'Progressive',
        State: 'CO',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 1375.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 107,
        PolicyCount: 0,
        RateCallCount: 107,
        RateCallSuccess: 106,
        RateCallError: 1,
        AvgRateCallPremium: 701.622641,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 218,
        PolicyCount: 6,
        RateCallCount: 212,
        RateCallSuccess: 134,
        RateCallError: 78,
        AvgRateCallPremium: 1341.64,
        AvgPolicyPremium: 959.333333,
      },
      {
        CarrierName: 'Progressive',
        State: 'DC',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 1016,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'DE',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'FL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 182,
        PolicyCount: 0,
        RateCallCount: 182,
        RateCallSuccess: 143,
        RateCallError: 39,
        AvgRateCallPremium: 976.960784,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 543,
        PolicyCount: 1,
        RateCallCount: 542,
        RateCallSuccess: 121,
        RateCallError: 421,
        AvgRateCallPremium: 822.798319,
        AvgPolicyPremium: 928,
      },
      {
        CarrierName: 'Progressive',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 37,
        PolicyCount: 1,
        RateCallCount: 36,
        RateCallSuccess: 35,
        RateCallError: 1,
        AvgRateCallPremium: 919.470588,
        AvgPolicyPremium: 1652,
      },
      {
        CarrierName: 'Progressive',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 803,
        PolicyCount: 21,
        RateCallCount: 782,
        RateCallSuccess: 607,
        RateCallError: 175,
        AvgRateCallPremium: 1702.227586,
        AvgPolicyPremium: 1621.523809,
      },
      {
        CarrierName: 'Progressive',
        State: 'FL',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 5,
        RateCallError: 1,
        AvgRateCallPremium: 1887.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 236,
        RateCallError: 6,
        AvgRateCallPremium: 1645.144067,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 37,
        RateCallError: 9,
        AvgRateCallPremium: 678.243243,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IA',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 4,
        RateCallError: 5,
        AvgRateCallPremium: 1021.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 14,
        RateCallError: 0,
        AvgRateCallPremium: 500,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'ID',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 1049.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 37,
        RateCallError: 10,
        AvgRateCallPremium: 2119.727272,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 122,
        PolicyCount: 0,
        RateCallCount: 122,
        RateCallSuccess: 105,
        RateCallError: 17,
        AvgRateCallPremium: 627.84466,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 81,
        PolicyCount: 1,
        RateCallCount: 80,
        RateCallSuccess: 66,
        RateCallError: 14,
        AvgRateCallPremium: 974.028571,
        AvgPolicyPremium: 701,
      },
      {
        CarrierName: 'Progressive',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 13,
        RateCallError: 4,
        AvgRateCallPremium: 1080,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 64,
        PolicyCount: 0,
        RateCallCount: 64,
        RateCallSuccess: 61,
        RateCallError: 3,
        AvgRateCallPremium: 997.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'KS',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 3,
        RateCallError: 1,
        AvgRateCallPremium: 438.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 99,
        PolicyCount: 2,
        RateCallCount: 97,
        RateCallSuccess: 92,
        RateCallError: 5,
        AvgRateCallPremium: 1139.945733,
        AvgPolicyPremium: 837.305,
      },
      {
        CarrierName: 'Progressive',
        State: 'KY',
        login_name: 'johndoe@email.com',
        CustomerCount: 109,
        PolicyCount: 0,
        RateCallCount: 109,
        RateCallSuccess: 82,
        RateCallError: 27,
        AvgRateCallPremium: 975.454313,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'LA',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 9,
        RateCallError: 1,
        AvgRateCallPremium: 628.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'LA',
        login_name: 'johndoe@email.com',
        CustomerCount: 118,
        PolicyCount: 1,
        RateCallCount: 117,
        RateCallSuccess: 101,
        RateCallError: 16,
        AvgRateCallPremium: 2378.075471,
        AvgPolicyPremium: 9562,
      },
      {
        CarrierName: 'Progressive',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 72,
        PolicyCount: 3,
        RateCallCount: 69,
        RateCallSuccess: 63,
        RateCallError: 6,
        AvgRateCallPremium: 865.642857,
        AvgPolicyPremium: 1042,
      },
      {
        CarrierName: 'Progressive',
        State: 'MD',
        login_name: 'johndoe@email.com',
        CustomerCount: 47,
        PolicyCount: 1,
        RateCallCount: 46,
        RateCallSuccess: 23,
        RateCallError: 23,
        AvgRateCallPremium: 1509.3125,
        AvgPolicyPremium: 913,
      },
      {
        CarrierName: 'Progressive',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 11,
        RateCallError: 2,
        AvgRateCallPremium: 466.090909,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'ME',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MI',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 3,
        RateCallError: 4,
        AvgRateCallPremium: 5019,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MI',
        login_name: 'consumer',
        CustomerCount: 143,
        PolicyCount: 0,
        RateCallCount: 143,
        RateCallSuccess: 127,
        RateCallError: 16,
        AvgRateCallPremium: 1323.934959,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MI',
        login_name: 'janedoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 9,
        RateCallError: 0,
        AvgRateCallPremium: 2187.555555,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 506,
        PolicyCount: 8,
        RateCallCount: 498,
        RateCallSuccess: 399,
        RateCallError: 99,
        AvgRateCallPremium: 3249.107758,
        AvgPolicyPremium: 2907.125,
      },
      {
        CarrierName: 'Progressive',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 60,
        RateCallError: 8,
        AvgRateCallPremium: 497.975,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MN',
        login_name: 'johndoe@email.com',
        CustomerCount: 56,
        PolicyCount: 0,
        RateCallCount: 56,
        RateCallSuccess: 40,
        RateCallError: 16,
        AvgRateCallPremium: 777.640625,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 16,
        RateCallError: 7,
        AvgRateCallPremium: 888.375,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MO',
        login_name: 'johndoe@email.com',
        CustomerCount: 56,
        PolicyCount: 2,
        RateCallCount: 54,
        RateCallSuccess: 38,
        RateCallError: 16,
        AvgRateCallPremium: 943.157894,
        AvgPolicyPremium: 4893.775,
      },
      {
        CarrierName: 'Progressive',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 59,
        RateCallError: 9,
        AvgRateCallPremium: 1018.033898,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 8,
        RateCallError: 1,
        AvgRateCallPremium: 1508.125,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 6,
        RateCallError: 0,
        AvgRateCallPremium: 375,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'MT',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 1453.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 71,
        PolicyCount: 0,
        RateCallCount: 71,
        RateCallSuccess: 67,
        RateCallError: 4,
        AvgRateCallPremium: 698.494901,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NC',
        login_name: 'janedoe@email.com',
        CustomerCount: 12,
        PolicyCount: 0,
        RateCallCount: 12,
        RateCallSuccess: 9,
        RateCallError: 3,
        AvgRateCallPremium: 540.425,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 157,
        PolicyCount: 11,
        RateCallCount: 146,
        RateCallSuccess: 126,
        RateCallError: 20,
        AvgRateCallPremium: 1478.946567,
        AvgPolicyPremium: 1066.430909,
      },
      {
        CarrierName: 'Progressive',
        State: 'ND',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 14,
        RateCallError: 1,
        AvgRateCallPremium: 870.142857,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NE',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 886,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 6,
        RateCallError: 2,
        AvgRateCallPremium: 565.166666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NH',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 1670,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 4,
        RateCallError: 9,
        AvgRateCallPremium: 733.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NJ',
        login_name: 'janedoe@email.com',
        CustomerCount: 32,
        PolicyCount: 0,
        RateCallCount: 32,
        RateCallSuccess: 28,
        RateCallError: 4,
        AvgRateCallPremium: 1673.785714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 35,
        RateCallError: 12,
        AvgRateCallPremium: 766.771428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NM',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 2,
        RateCallError: 1,
        AvgRateCallPremium: 1034,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NV',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 1,
        RateCallError: 6,
        AvgRateCallPremium: 528,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 28,
        RateCallError: 1,
        AvgRateCallPremium: 857.65,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NY',
        login_name: 'janedoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 3,
        RateCallError: 0,
        AvgRateCallPremium: 855.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'NY',
        login_name: 'johndoe@email.com',
        CustomerCount: 434,
        PolicyCount: 5,
        RateCallCount: 429,
        RateCallSuccess: 310,
        RateCallError: 119,
        AvgRateCallPremium: 2143.396551,
        AvgPolicyPremium: 1240.756,
      },
      {
        CarrierName: 'Progressive',
        State: 'NY',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 29,
        RateCallError: 5,
        AvgRateCallPremium: 2456.48,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 14,
        RateCallError: 1,
        AvgRateCallPremium: 531.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 36,
        PolicyCount: 2,
        RateCallCount: 34,
        RateCallSuccess: 33,
        RateCallError: 1,
        AvgRateCallPremium: 431.366666,
        AvgPolicyPremium: 302.5,
      },
      {
        CarrierName: 'Progressive',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 180,
        PolicyCount: 13,
        RateCallCount: 167,
        RateCallSuccess: 133,
        RateCallError: 34,
        AvgRateCallPremium: 607.346938,
        AvgPolicyPremium: 710.615384,
      },
      {
        CarrierName: 'Progressive',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 18,
        PolicyCount: 0,
        RateCallCount: 18,
        RateCallSuccess: 16,
        RateCallError: 2,
        AvgRateCallPremium: 780.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'OK',
        login_name: 'johndoe@email.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 34,
        RateCallError: 0,
        AvgRateCallPremium: 1107.882352,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 15,
        RateCallError: 12,
        AvgRateCallPremium: 437,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 624.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 85,
        RateCallError: 17,
        AvgRateCallPremium: 885.717647,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 49,
        PolicyCount: 1,
        RateCallCount: 48,
        RateCallSuccess: 43,
        RateCallError: 5,
        AvgRateCallPremium: 870.166666,
        AvgPolicyPremium: 1675,
      },
      {
        CarrierName: 'Progressive',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 3,
        RateCallError: 0,
        AvgRateCallPremium: 452,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'RI',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 2511,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 24,
        RateCallError: 24,
        AvgRateCallPremium: 824.208333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'SC',
        login_name: 'johndoe@email.com',
        CustomerCount: 38,
        PolicyCount: 0,
        RateCallCount: 38,
        RateCallSuccess: 37,
        RateCallError: 1,
        AvgRateCallPremium: 1321.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'SD',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 6,
        RateCallError: 2,
        AvgRateCallPremium: 382,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 1011,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 113,
        RateCallError: 11,
        AvgRateCallPremium: 864.035398,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 51,
        PolicyCount: 1,
        RateCallCount: 50,
        RateCallSuccess: 41,
        RateCallError: 9,
        AvgRateCallPremium: 1130.275862,
        AvgPolicyPremium: 1654,
      },
      {
        CarrierName: 'Progressive',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 11,
        RateCallError: 6,
        AvgRateCallPremium: 1025.363636,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'UT',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 3,
        RateCallError: 0,
        AvgRateCallPremium: 906,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 28,
        PolicyCount: 0,
        RateCallCount: 28,
        RateCallSuccess: 24,
        RateCallError: 4,
        AvgRateCallPremium: 469.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'VA',
        login_name: 'johndoe@email.com',
        CustomerCount: 82,
        PolicyCount: 2,
        RateCallCount: 80,
        RateCallSuccess: 62,
        RateCallError: 18,
        AvgRateCallPremium: 1251.774193,
        AvgPolicyPremium: 943,
      },
      {
        CarrierName: 'Progressive',
        State: 'VT',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 194,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 426.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 50,
        PolicyCount: 1,
        RateCallCount: 49,
        RateCallSuccess: 40,
        RateCallError: 9,
        AvgRateCallPremium: 1388.173913,
        AvgPolicyPremium: 672,
      },
      {
        CarrierName: 'Progressive',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 6,
        RateCallError: 0,
        AvgRateCallPremium: 638.166666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WI',
        login_name: 'johndoe@email.com',
        CustomerCount: 41,
        PolicyCount: 0,
        RateCallCount: 41,
        RateCallSuccess: 27,
        RateCallError: 14,
        AvgRateCallPremium: 1355.294117,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 15,
        RateCallError: 0,
        AvgRateCallPremium: 1092.98,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WV',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 2,
        RateCallError: 1,
        AvgRateCallPremium: 393.655,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Progressive',
        State: 'WY',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 524,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 98,
        RateCallError: 144,
        AvgRateCallPremium: 3334.908163,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 5,
        RateCallError: 114,
        AvgRateCallPremium: 420,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 12,
        RateCallError: 5,
        AvgRateCallPremium: 1136.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 37,
        RateCallError: 40,
        AvgRateCallPremium: 1311.844324,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 0,
        RateCallError: 23,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 19,
        RateCallError: 49,
        AvgRateCallPremium: 1378.68421,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 15,
        RateCallError: 16,
        AvgRateCallPremium: 823.933333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 6,
        RateCallError: 11,
        AvgRateCallPremium: 1219.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 20,
        RateCallError: 82,
        AvgRateCallPremium: 810.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 31,
        RateCallError: 17,
        AvgRateCallPremium: 1625.991935,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 18,
        RateCallError: 106,
        AvgRateCallPremium: 2651.611111,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safe Auto',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 2,
        RateCallError: 25,
        AvgRateCallPremium: 547,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'AL',
        login_name: 'janedoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 1,
        RateCallError: 4,
        AvgRateCallPremium: 2895.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'AL',
        login_name: 'johndoe@email.com',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 1,
        RateCallError: 13,
        AvgRateCallPremium: 3050.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'AR',
        login_name: 'johndoe@email.com',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 1,
        RateCallError: 9,
        AvgRateCallPremium: 2954.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 73,
        PolicyCount: 0,
        RateCallCount: 73,
        RateCallSuccess: 15,
        RateCallError: 58,
        AvgRateCallPremium: 2281.173333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 0,
        RateCallError: 385,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 171,
        PolicyCount: 1,
        RateCallCount: 170,
        RateCallSuccess: 0,
        RateCallError: 170,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 2222.22,
      },
      {
        CarrierName: 'Safeco',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 12,
        RateCallError: 37,
        AvgRateCallPremium: 3136,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'CO',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 9,
        RateCallError: 15,
        AvgRateCallPremium: 2200.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'CO',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 2268.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 42,
        PolicyCount: 1,
        RateCallCount: 41,
        RateCallSuccess: 6,
        RateCallError: 35,
        AvgRateCallPremium: 2493.616666,
        AvgPolicyPremium: 456.55,
      },
      {
        CarrierName: 'Safeco',
        State: 'DC',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'FL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 59,
        PolicyCount: 0,
        RateCallCount: 59,
        RateCallSuccess: 0,
        RateCallError: 59,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 0,
        RateCallError: 539,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 2,
        RateCallError: 33,
        AvgRateCallPremium: 3178.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'FL',
        login_name: 'johndoe@email.com',
        CustomerCount: 383,
        PolicyCount: 1,
        RateCallCount: 382,
        RateCallSuccess: 43,
        RateCallError: 339,
        AvgRateCallPremium: 6032.072093,
        AvgPolicyPremium: 300,
      },
      {
        CarrierName: 'Safeco',
        State: 'FL',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'GA',
        login_name: 'johndoe@email.com',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 1,
        RateCallError: 28,
        AvgRateCallPremium: 3567.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IA',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 3639.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 0,
        RateCallError: 14,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'ID',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 2,
        RateCallError: 3,
        AvgRateCallPremium: 2258.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 0,
        RateCallError: 16,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 33,
        RateCallError: 86,
        AvgRateCallPremium: 2314.645454,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 43,
        PolicyCount: 0,
        RateCallCount: 43,
        RateCallSuccess: 15,
        RateCallError: 28,
        AvgRateCallPremium: 2668.16,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 29,
        PolicyCount: 0,
        RateCallCount: 29,
        RateCallSuccess: 1,
        RateCallError: 28,
        AvgRateCallPremium: 1181.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'KS',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 1,
        RateCallError: 3,
        AvgRateCallPremium: 1786.4,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'KY',
        login_name: 'johndoe@email.com',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 3,
        RateCallError: 10,
        AvgRateCallPremium: 1973.733333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'LA',
        login_name: 'johndoe@email.com',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 0,
        RateCallError: 11,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MD',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 1,
        RateCallError: 8,
        AvgRateCallPremium: 1428.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MI',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 0,
        RateCallError: 4,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MI',
        login_name: 'janedoe@email.com',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 3954.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MI',
        login_name: 'johndoe@email.com',
        CustomerCount: 252,
        PolicyCount: 0,
        RateCallCount: 252,
        RateCallSuccess: 1,
        RateCallError: 251,
        AvgRateCallPremium: 3640.7,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 0,
        RateCallError: 68,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MN',
        login_name: 'janedoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 5607.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MN',
        login_name: 'johndoe@email.com',
        CustomerCount: 33,
        PolicyCount: 0,
        RateCallCount: 33,
        RateCallSuccess: 6,
        RateCallError: 27,
        AvgRateCallPremium: 2959.55,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 18,
        RateCallError: 5,
        AvgRateCallPremium: 1648.252777,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MO',
        login_name: 'johndoe@email.com',
        CustomerCount: 28,
        PolicyCount: 0,
        RateCallCount: 28,
        RateCallSuccess: 28,
        RateCallError: 0,
        AvgRateCallPremium: 1811.998571,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 1,
        RateCallError: 6,
        AvgRateCallPremium: 1820.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'MT',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 3140.1,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NC',
        login_name: 'janedoe@email.com',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 2,
        RateCallError: 6,
        AvgRateCallPremium: 1230.46,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NC',
        login_name: 'johndoe@email.com',
        CustomerCount: 45,
        PolicyCount: 0,
        RateCallCount: 45,
        RateCallSuccess: 2,
        RateCallError: 43,
        AvgRateCallPremium: 1737.05,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'ND',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 3196.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 6,
        RateCallError: 9,
        AvgRateCallPremium: 3151.833333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NE',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 2465.3,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 0,
        RateCallError: 8,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NH',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 3258.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 0,
        RateCallError: 13,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 1,
        RateCallError: 46,
        AvgRateCallPremium: 2225.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NM',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 2831.7,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NV',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 1,
        RateCallError: 6,
        AvgRateCallPremium: 1077.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NY',
        login_name: 'consumer',
        CustomerCount: 21,
        PolicyCount: 0,
        RateCallCount: 21,
        RateCallSuccess: 0,
        RateCallError: 21,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NY',
        login_name: 'janedoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 2,
        RateCallError: 1,
        AvgRateCallPremium: 2191.96,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NY',
        login_name: 'johndoe@email.com',
        CustomerCount: 98,
        PolicyCount: 0,
        RateCallCount: 98,
        RateCallSuccess: 10,
        RateCallError: 88,
        AvgRateCallPremium: 1752.706,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'NY',
        login_name: 'spahurkar@quinstreet.com',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 0,
        RateCallError: 15,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 6,
        RateCallError: 0,
        AvgRateCallPremium: 2520.973333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 16,
        RateCallError: 15,
        AvgRateCallPremium: 1172.608125,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 109,
        PolicyCount: 0,
        RateCallCount: 109,
        RateCallSuccess: 100,
        RateCallError: 9,
        AvgRateCallPremium: 974.7877,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'OK',
        login_name: 'johndoe@email.com',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 1,
        RateCallError: 10,
        AvgRateCallPremium: 2224.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 1,
        RateCallError: 4,
        AvgRateCallPremium: 1336.4,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 2,
        RateCallError: 100,
        AvgRateCallPremium: 2197.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 2,
        RateCallError: 24,
        AvgRateCallPremium: 1593,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'SC',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'SD',
        login_name: 'consumer',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'SD',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 1963.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 1,
        RateCallError: 7,
        AvgRateCallPremium: 2014.8,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 2881.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 39,
        RateCallError: 85,
        AvgRateCallPremium: 2271.573333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 34,
        PolicyCount: 0,
        RateCallCount: 34,
        RateCallSuccess: 3,
        RateCallError: 31,
        AvgRateCallPremium: 1553.6,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 7,
        RateCallError: 10,
        AvgRateCallPremium: 2097,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'UT',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 2297.2,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'VA',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 1,
        RateCallError: 8,
        AvgRateCallPremium: 1283.9,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'VT',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 616.9,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 1,
        RateCallError: 4,
        AvgRateCallPremium: 1931.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 26,
        PolicyCount: 0,
        RateCallCount: 26,
        RateCallSuccess: 3,
        RateCallError: 23,
        AvgRateCallPremium: 2912.966666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WI',
        login_name: 'janedoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 1850.7,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WI',
        login_name: 'johndoe@email.com',
        CustomerCount: 24,
        PolicyCount: 0,
        RateCallCount: 24,
        RateCallSuccess: 2,
        RateCallError: 22,
        AvgRateCallPremium: 3836.55,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WV',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 1,
        RateCallError: 2,
        AvgRateCallPremium: 1155.62,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeco',
        State: 'WY',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 2008.5,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeway',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 205,
        RateCallError: 180,
        AvgRateCallPremium: 1248.865121,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Safeway',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 10,
        RateCallError: 7,
        AvgRateCallPremium: 939.482,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'AZ',
        login_name: 'johndoe@email.com',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 4,
        RateCallError: 31,
        AvgRateCallPremium: 1244.75,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 56,
        PolicyCount: 1,
        RateCallCount: 55,
        RateCallSuccess: 15,
        RateCallError: 40,
        AvgRateCallPremium: 1021.98,
        AvgPolicyPremium: 4521.45,
      },
      {
        CarrierName: 'Stillwater',
        State: 'CT',
        login_name: 'johndoe@email.com',
        CustomerCount: 54,
        PolicyCount: 0,
        RateCallCount: 54,
        RateCallSuccess: 10,
        RateCallError: 44,
        AvgRateCallPremium: 684,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'ID',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 0,
        RateCallError: 5,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'IL',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'IL',
        login_name: 'johndoe@email.com',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 0,
        RateCallError: 16,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'IN',
        login_name: 'johndoe@email.com',
        CustomerCount: 4,
        PolicyCount: 0,
        RateCallCount: 4,
        RateCallSuccess: 1,
        RateCallError: 3,
        AvgRateCallPremium: 800,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'MN',
        login_name: 'johndoe@email.com',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 0,
        RateCallError: 6,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'OH',
        login_name: 'aevans@quinstreet.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'OH',
        login_name: 'johndoe@email.com',
        CustomerCount: 56,
        PolicyCount: 1,
        RateCallCount: 55,
        RateCallSuccess: 20,
        RateCallError: 35,
        AvgRateCallPremium: 622.4,
        AvgPolicyPremium: 123.45,
      },
      {
        CarrierName: 'Stillwater',
        State: 'OR',
        login_name: 'johndoe@email.com',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 2,
        RateCallError: 3,
        AvgRateCallPremium: 404,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'PA',
        login_name: 'johndoe@email.com',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 0,
        RateCallError: 9,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'RI',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 1,
        RateCallError: 1,
        AvgRateCallPremium: 1303,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'SC',
        login_name: 'johndoe@email.com',
        CustomerCount: 7,
        PolicyCount: 0,
        RateCallCount: 7,
        RateCallSuccess: 3,
        RateCallError: 4,
        AvgRateCallPremium: 740.666666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'TN',
        login_name: 'johndoe@email.com',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 0,
        RateCallError: 2,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'TX',
        login_name: 'johndoe@email.com',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 0,
        RateCallError: 10,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'UT',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 2,
        RateCallError: 1,
        AvgRateCallPremium: 658,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'VA',
        login_name: 'johndoe@email.com',
        CustomerCount: 3,
        PolicyCount: 0,
        RateCallCount: 3,
        RateCallSuccess: 0,
        RateCallError: 3,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Stillwater',
        State: 'WA',
        login_name: 'johndoe@email.com',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 3,
        RateCallError: 5,
        AvgRateCallPremium: 1700.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 282,
        PolicyCount: 0,
        RateCallCount: 282,
        RateCallSuccess: 273,
        RateCallError: 9,
        AvgRateCallPremium: 1373.029597,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 153,
        PolicyCount: 0,
        RateCallCount: 153,
        RateCallSuccess: 131,
        RateCallError: 22,
        AvgRateCallPremium: 1807.574961,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 5,
        RateCallError: 6,
        AvgRateCallPremium: 1754.096,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 385,
        PolicyCount: 0,
        RateCallCount: 385,
        RateCallSuccess: 0,
        RateCallError: 385,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 49,
        PolicyCount: 0,
        RateCallCount: 49,
        RateCallSuccess: 29,
        RateCallError: 20,
        AvgRateCallPremium: 1927.022758,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 539,
        PolicyCount: 0,
        RateCallCount: 539,
        RateCallSuccess: 505,
        RateCallError: 34,
        AvgRateCallPremium: 4390.691485,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'FL',
        login_name: 'janedoe@email.com',
        CustomerCount: 19,
        PolicyCount: 0,
        RateCallCount: 19,
        RateCallSuccess: 9,
        RateCallError: 10,
        AvgRateCallPremium: 3820.488888,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 242,
        PolicyCount: 0,
        RateCallCount: 242,
        RateCallSuccess: 239,
        RateCallError: 3,
        AvgRateCallPremium: 3393.239665,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 46,
        PolicyCount: 0,
        RateCallCount: 46,
        RateCallSuccess: 37,
        RateCallError: 9,
        AvgRateCallPremium: 1423.351351,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 14,
        RateCallError: 0,
        AvgRateCallPremium: 1200.734285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 119,
        PolicyCount: 0,
        RateCallCount: 119,
        RateCallSuccess: 89,
        RateCallError: 30,
        AvgRateCallPremium: 1527.587865,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 14,
        RateCallError: 3,
        AvgRateCallPremium: 1398.571428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 1220.24,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 77,
        PolicyCount: 0,
        RateCallCount: 77,
        RateCallSuccess: 77,
        RateCallError: 0,
        AvgRateCallPremium: 1721.032207,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'LA',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 9,
        RateCallError: 0,
        AvgRateCallPremium: 1919.555555,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 37,
        RateCallError: 24,
        AvgRateCallPremium: 2240.459459,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 13,
        RateCallError: 0,
        AvgRateCallPremium: 935.461538,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 47,
        RateCallError: 21,
        AvgRateCallPremium: 2322.829787,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 11,
        RateCallError: 12,
        AvgRateCallPremium: 2621.181818,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 68,
        PolicyCount: 0,
        RateCallCount: 68,
        RateCallSuccess: 66,
        RateCallError: 2,
        AvgRateCallPremium: 1329.364848,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MS',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'MT',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 6,
        RateCallError: 0,
        AvgRateCallPremium: 993.333333,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 15,
        PolicyCount: 0,
        RateCallCount: 15,
        RateCallSuccess: 14,
        RateCallError: 1,
        AvgRateCallPremium: 1493.571428,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 8,
        RateCallError: 0,
        AvgRateCallPremium: 931.61,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 43,
        RateCallError: 4,
        AvgRateCallPremium: 1204.306046,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 31,
        PolicyCount: 0,
        RateCallCount: 31,
        RateCallSuccess: 18,
        RateCallError: 13,
        AvgRateCallPremium: 1084.731111,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 14,
        RateCallError: 3,
        AvgRateCallPremium: 2385.928571,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 25,
        RateCallError: 2,
        AvgRateCallPremium: 1564.16,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 85,
        RateCallError: 17,
        AvgRateCallPremium: 1196.230588,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 0,
        RateCallError: 17,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 48,
        PolicyCount: 0,
        RateCallCount: 48,
        RateCallSuccess: 46,
        RateCallError: 2,
        AvgRateCallPremium: 1991.244347,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'SD',
        login_name: 'consumer',
        CustomerCount: 2,
        PolicyCount: 0,
        RateCallCount: 2,
        RateCallSuccess: 2,
        RateCallError: 0,
        AvgRateCallPremium: 1114.12,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 8,
        RateCallError: 0,
        AvgRateCallPremium: 885.375,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 115,
        RateCallError: 9,
        AvgRateCallPremium: 2611.141217,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 13,
        RateCallError: 4,
        AvgRateCallPremium: 1083.230769,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 6,
        RateCallError: 21,
        AvgRateCallPremium: 2016.086666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 1199.24,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 5,
        RateCallError: 1,
        AvgRateCallPremium: 962.728,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'The General',
        State: 'WV',
        login_name: 'consumer',
        CustomerCount: 65,
        PolicyCount: 0,
        RateCallCount: 65,
        RateCallSuccess: 65,
        RateCallError: 0,
        AvgRateCallPremium: 2286.435538,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'AL',
        login_name: 'consumer',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 7,
        RateCallError: 3,
        AvgRateCallPremium: 1275.052857,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'AR',
        login_name: 'consumer',
        CustomerCount: 83,
        PolicyCount: 0,
        RateCallCount: 83,
        RateCallSuccess: 53,
        RateCallError: 30,
        AvgRateCallPremium: 987.708113,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'AZ',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 5,
        RateCallError: 6,
        AvgRateCallPremium: 1318.408,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'CA',
        login_name: 'consumer',
        CustomerCount: 113,
        PolicyCount: 0,
        RateCallCount: 113,
        RateCallSuccess: 43,
        RateCallError: 70,
        AvgRateCallPremium: 1020.702558,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'CA',
        login_name: 'johndoe@email.com',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 0,
        RateCallError: 1,
        AvgRateCallPremium: 'NULL',
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'CO',
        login_name: 'consumer',
        CustomerCount: 22,
        PolicyCount: 0,
        RateCallCount: 22,
        RateCallSuccess: 20,
        RateCallError: 2,
        AvgRateCallPremium: 2037.763,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'CT',
        login_name: 'consumer',
        CustomerCount: 67,
        PolicyCount: 0,
        RateCallCount: 67,
        RateCallSuccess: 29,
        RateCallError: 38,
        AvgRateCallPremium: 1446.29,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'FL',
        login_name: 'consumer',
        CustomerCount: 82,
        PolicyCount: 0,
        RateCallCount: 82,
        RateCallSuccess: 34,
        RateCallError: 48,
        AvgRateCallPremium: 1907.974117,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'GA',
        login_name: 'consumer',
        CustomerCount: 130,
        PolicyCount: 0,
        RateCallCount: 130,
        RateCallSuccess: 49,
        RateCallError: 81,
        AvgRateCallPremium: 2236.621224,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'IA',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 16,
        RateCallError: 7,
        AvgRateCallPremium: 1075.8825,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'ID',
        login_name: 'consumer',
        CustomerCount: 14,
        PolicyCount: 0,
        RateCallCount: 14,
        RateCallSuccess: 4,
        RateCallError: 10,
        AvgRateCallPremium: 835.9925,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'IL',
        login_name: 'consumer',
        CustomerCount: 45,
        PolicyCount: 0,
        RateCallCount: 45,
        RateCallSuccess: 29,
        RateCallError: 16,
        AvgRateCallPremium: 1250.464482,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'IN',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 5,
        RateCallError: 6,
        AvgRateCallPremium: 1868.734,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'KS',
        login_name: 'consumer',
        CustomerCount: 1,
        PolicyCount: 0,
        RateCallCount: 1,
        RateCallSuccess: 1,
        RateCallError: 0,
        AvgRateCallPremium: 1284.99,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'KY',
        login_name: 'consumer',
        CustomerCount: 47,
        PolicyCount: 0,
        RateCallCount: 47,
        RateCallSuccess: 35,
        RateCallError: 12,
        AvgRateCallPremium: 1745.343714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'MD',
        login_name: 'consumer',
        CustomerCount: 61,
        PolicyCount: 0,
        RateCallCount: 61,
        RateCallSuccess: 56,
        RateCallError: 5,
        AvgRateCallPremium: 1202.250535,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'ME',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 7,
        RateCallError: 6,
        AvgRateCallPremium: 886.344285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'MN',
        login_name: 'consumer',
        CustomerCount: 57,
        PolicyCount: 0,
        RateCallCount: 57,
        RateCallSuccess: 22,
        RateCallError: 35,
        AvgRateCallPremium: 2073.559545,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'MO',
        login_name: 'consumer',
        CustomerCount: 23,
        PolicyCount: 0,
        RateCallCount: 23,
        RateCallSuccess: 7,
        RateCallError: 16,
        AvgRateCallPremium: 1401.998571,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'MS',
        login_name: 'consumer',
        CustomerCount: 16,
        PolicyCount: 0,
        RateCallCount: 16,
        RateCallSuccess: 11,
        RateCallError: 5,
        AvgRateCallPremium: 1431.84,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'NC',
        login_name: 'consumer',
        CustomerCount: 35,
        PolicyCount: 0,
        RateCallCount: 35,
        RateCallSuccess: 23,
        RateCallError: 12,
        AvgRateCallPremium: 1123.897391,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'NE',
        login_name: 'consumer',
        CustomerCount: 10,
        PolicyCount: 0,
        RateCallCount: 10,
        RateCallSuccess: 7,
        RateCallError: 3,
        AvgRateCallPremium: 1058.944285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'NH',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 7,
        RateCallError: 1,
        AvgRateCallPremium: 1018.664285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'NJ',
        login_name: 'consumer',
        CustomerCount: 13,
        PolicyCount: 0,
        RateCallCount: 13,
        RateCallSuccess: 10,
        RateCallError: 3,
        AvgRateCallPremium: 1584.451,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'NM',
        login_name: 'consumer',
        CustomerCount: 18,
        PolicyCount: 0,
        RateCallCount: 18,
        RateCallSuccess: 11,
        RateCallError: 7,
        AvgRateCallPremium: 1383.816363,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'OH',
        login_name: 'consumer',
        CustomerCount: 22,
        PolicyCount: 0,
        RateCallCount: 22,
        RateCallSuccess: 18,
        RateCallError: 4,
        AvgRateCallPremium: 731.166666,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'OK',
        login_name: 'consumer',
        CustomerCount: 9,
        PolicyCount: 0,
        RateCallCount: 9,
        RateCallSuccess: 5,
        RateCallError: 4,
        AvgRateCallPremium: 2033.656,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'OR',
        login_name: 'consumer',
        CustomerCount: 18,
        PolicyCount: 0,
        RateCallCount: 18,
        RateCallSuccess: 14,
        RateCallError: 4,
        AvgRateCallPremium: 773.639285,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'PA',
        login_name: 'consumer',
        CustomerCount: 102,
        PolicyCount: 0,
        RateCallCount: 102,
        RateCallSuccess: 85,
        RateCallError: 17,
        AvgRateCallPremium: 920.578588,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'RI',
        login_name: 'consumer',
        CustomerCount: 11,
        PolicyCount: 0,
        RateCallCount: 11,
        RateCallSuccess: 4,
        RateCallError: 7,
        AvgRateCallPremium: 1233.7525,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'SC',
        login_name: 'consumer',
        CustomerCount: 33,
        PolicyCount: 0,
        RateCallCount: 33,
        RateCallSuccess: 17,
        RateCallError: 16,
        AvgRateCallPremium: 986.465294,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'TN',
        login_name: 'consumer',
        CustomerCount: 8,
        PolicyCount: 0,
        RateCallCount: 8,
        RateCallSuccess: 4,
        RateCallError: 4,
        AvgRateCallPremium: 966.8275,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'TX',
        login_name: 'consumer',
        CustomerCount: 124,
        PolicyCount: 0,
        RateCallCount: 124,
        RateCallSuccess: 76,
        RateCallError: 48,
        AvgRateCallPremium: 1671.381315,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'UT',
        login_name: 'consumer',
        CustomerCount: 17,
        PolicyCount: 0,
        RateCallCount: 17,
        RateCallSuccess: 7,
        RateCallError: 10,
        AvgRateCallPremium: 1000.095714,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'VA',
        login_name: 'consumer',
        CustomerCount: 27,
        PolicyCount: 0,
        RateCallCount: 27,
        RateCallSuccess: 19,
        RateCallError: 8,
        AvgRateCallPremium: 1140.270526,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'WA',
        login_name: 'consumer',
        CustomerCount: 5,
        PolicyCount: 0,
        RateCallCount: 5,
        RateCallSuccess: 5,
        RateCallError: 0,
        AvgRateCallPremium: 968.212,
        AvgPolicyPremium: 'NULL',
      },
      {
        CarrierName: 'Travelers',
        State: 'WI',
        login_name: 'consumer',
        CustomerCount: 6,
        PolicyCount: 0,
        RateCallCount: 6,
        RateCallSuccess: 6,
        RateCallError: 0,
        AvgRateCallPremium: 850.328333,
        AvgPolicyPremium: 'NULL',
      },
    ],
    title: 'Agent Activity',
  },
  reportSummary: {
    carriers: {},
    columns: {
      CustomerCount: 'Carrier Performance',
      RateCallCount: 'Completed Rate Calls',
      PolicyCount: 'Total Sold Policy Count',
      AvgPolicyPremium: 'Avg. Sold Policy Premium',
    },
    states: {},
    teams: {},
    datarows: [],
    summary: {
      CustomerCount: 999,
      RateCallCount: 10,
      PolicyCount: 0,
      AvgPolicyPremium: null,
    },
  },
  pageData: {
      page_name: 'HAOccupants',
      tab_buttons: [
        {
          name: 'NamedInsured',
          label: 'Named Insured',
          status: 'ActiveComplete',
          type: 'Tab',
          on_click: '/navs/NamedInsuredTab',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'Vehicles',
          label: 'Vehicle(s)',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/VehiclesTab',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'Drivers',
          label: 'Driver(s)',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/DriversTab',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'PriorInsurance',
          label: 'Prior Insurance',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/PriorInsuranceTab',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'NewCoverages',
          label: 'New Coverages',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/NewCoveragesTab',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'CarrierMatches',
          label: 'Carrier Matches',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/CarrierMatches',
          action: 'POST',
          section: 'RC1',
        },
        {
          name: 'ContactDetails',
          label: 'Contact Details',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/ContactDetailsTab',
          action: 'POST',
          section: 'RC2',
        },
        {
          name: 'DriverVehicleDetails',
          label: 'Driver/Vehicle Details',
          status: 'InactiveIncomplete',
          type: 'Tab',
          on_click: '/navs/DriverVehicleDetailsTab',
          action: 'POST',
          section: 'RC2',
        },
        {
          name: 'PolicyDetails',
          label: 'Policy Details',
          status: 'InactiveComplete',
          type: 'Tab',
          on_click: '/navs/PolicyDetailsTab',
          action: 'POST',
          section: 'RC2',
        },
        {
          name: 'Checkout',
          label: 'Checkout',
          status: 'InactiveIncomplete',
          type: 'Tab',
          on_click: '/navs/CheckoutTab',
          action: 'POST',
          section: 'RC2',
        },
        {
          name: 'Confirmation',
          label: 'Confirmation',
          status: 'Disabled',
          type: 'Tab',
          on_click: '/navs/ConfirmationTab',
          action: 'POST',
          section: 'RC2',
        },
      ],
      continue_buttons: [
        {
          name: 'ContinueButton',
          label: 'SAVE & CONTINUE TO VEHICLE(S)',
          status: 'Enabled',
          type: 'Continue',
          on_click: '/navs/NamedInsuredContinue',
          action: 'POST',
          section: null,
        },
      ],
      polk_buttons: [],
      new_buttons: [],
      section_buttons: [],
      add_buttons: [
        {
          name: 'AddVehicle',
          label: 'Click Me Button',
          status: 'Enabled',
          type: 'Add',
          on_click: '/rules/AddVehicle/QTE_VEH__Veh',
          action: 'POST',
          section: 'Section TWO',
        },
        {
          name: 'asdf',
          label: 'ADD VEHICLE',
          status: 'Enabled',
          type: 'Add',
          on_click: '/rules/AddVehicle/QTE_VEH__Veh',
          action: 'POST',
          section: null,
        },
        {
          name: 'asdf',
          label: 'Add another Thing',
          status: 'Enabled',
          type: 'Add',
          on_click: '/rules/AddVehicle/SOME_THREE_THING',
          action: 'POST',
          section: 'Section THREE',
        },
        {
          name: 'asdf',
          label: 'Add Claim',
          status: 'Enabled',
          type: 'Add',
          on_click: '/rules/AddVehicle/QTE_VEH__Veh',
          action: 'POST',
          section: 'Previous Claims',
        },
      ],
      fields: [
        {
          field_name: 'QTE_FirstName',
          field_type: 'text_large',
          label: 'First Name',
          field_value: 'Testfirstname',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 1,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Occupant',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'FieldRequiredNameFormat',
              rule: '{ "required": true, "regex": "^[a-zA-Z-\' ]+$" }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_MiddleInitial',
          field_type: 'text_short',
          label: 'Middle Initial',
          field_value: '',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 2,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: false,
          script: '',
          max_length: 1,
          section: 'Occupant',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'OneCharacterField',
              rule: '{ "required": false, "alpha": true, "max": 1}',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_LastName',
          field_type: 'text_large',
          label: 'Last Name',
          field_value: 'Desmarais',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 3,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Section TWO',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'FieldRequiredNameFormat',
              rule: '{ "required": true, "regex": "^[a-zA-Z-\' ]+$" }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_ShouldGetPolkVvsData',
          field_type: 'radio',
          label: 'How a many yes or no do you?',
          field_value: 'true',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 13,
          section_display_order: 0,
          help_text: 'POLK is a report that expedites the quoting process by providing vehicle and driver information associated with a specific address.',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: true,
          is_required: false,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'OptionalField',
              rule: '{ "required": false }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: 'Yes',
              internal_value: 'yes',
              visible: true,
              display_order: 1,
            },
            {
              display_value: 'No',
              internal_value: 'no',
              visible: true,
              display_order: 2,
            },
          ],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_NameSuffix',
          field_type: 'select_short',
          label: 'Suffix',
          field_value: '',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 4,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: false,
          script: '',
          max_length: 100,
          section: 'Section TWO',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'OptionalField',
              rule: '{ "required": false }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: 'Jr',
              internal_value: 'Jr',
              visible: true,
              display_order: 1,
            },
            {
              display_value: 'Sr',
              internal_value: 'Sr',
              visible: true,
              display_order: 2,
            },
            {
              display_value: 'I',
              internal_value: 'First',
              visible: true,
              display_order: 3,
            },
            {
              display_value: 'II',
              internal_value: 'Second',
              visible: true,
              display_order: 4,
            },
            {
              display_value: 'III',
              internal_value: 'Third',
              visible: true,
              display_order: 5,
            },
            {
              display_value: 'IV',
              internal_value: 'Fourth',
              visible: true,
              display_order: 6,
            },
          ],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_CurrentPhoneNumber',
          field_type: 'phonenumber_large',
          label: 'Phone Number',
          field_value: '2424242424',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: 'XXX-XXX-XXXX',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 10,
          section: 'Section TWO',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'PhoneNumberFormat',
              rule: '{ "required": true, "digits": 10 }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_EmailAddress',
          field_type: 'email_large',
          label: 'Email Address',
          field_value: 'polk-test@email.com',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 6,
          section_display_order: 0,
          help_text: 'If the customer does not have a valid email address, then use the “Generate Email Address” link to get rate quotes. A valid email will be required to purchase an insurance policy.',
          sub_text: '<a href="#" data-action="generate-email-address">Generate Email Address</a>',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Section TWO',
          section_type: '',
          sub_section: 'SubSection TWO-1',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'FieldRequiredEmailFormat',
              rule: '{ "required": true, "email": true }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_ResidentialStreetAddress',
          field_type: 'address_long',
          label: 'Street/Garaging Address',
          field_value: '2160 Southwest 85th Avenue',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 7,
          section_display_order: 0,
          help_text: 'This is the customer’s physical street address. Fractions should be written as three separate characters, 1/2. Enter all rural route/box combinations or APO/FPO addresses into the Street/Garaging Address field.',
          sub_text: 'Do not use P.O. Box numbers. Create a new quote to change states.',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Section TWO',
          section_type: '',
          sub_section: 'SubSection TWO-1',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_ResidentialUnitNumber',
          field_type: 'text_long',
          label: 'APT/Unit Number',
          field_value: '',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 8,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: false,
          script: '',
          max_length: 100,
          section: 'Section TWO',
          section_type: '',
          sub_section: 'SubSection TWO-1',
          sub_section_type: '',
          sub_index_section: 'SubSubSection TWO-1-1',
          sub_index_section_type: '',
          rules: [],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_ResidenceCity',
          field_type: 'text_long',
          label: 'City',
          field_value: 'North Lauderdale',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 9,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Section THREE',
          section_type: 'horizontal',
          sub_section: 'THREE-1',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_State',
          field_type: 'text_short_inline',
          label: 'State',
          field_value: 'FL',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 10,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 2,
          section: 'Section THREE',
          section_type: 'horizontal',
          sub_section: 'THREE-2',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'StateCodeFormat',
              rule: '{ "required": true, "alpha": true, "min": 2, "max": 2 }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_ResidenceZip',
          field_type: 'text_medium_right',
          label: 'Zip Code',
          field_value: '33068',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 11,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 5,
          section: '',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'RquiredZipCodeFormat',
              rule: '{ "required": true, "digits":5 }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_FCRAConsent',
          field_type: 'checkbox',
          label: 'Check this box to signify that you have read the above FCRA Statement and the applicant has given their consent to proceed.',
          field_value: 'true',
          group_id: 1,
          index: null,
          sub_index: null,
          display_order: 12,
          section_display_order: 0,
          help_text: 'Hard Stop: DO NOT check this box if the customer declines the FCRA Disclosure.',
          sub_text: '',
          placeholder: '',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: true,
          is_required: true,
          script: '<p><b>Read This FCRA Statement Verbatim</b> (FCRA)<br/> The carriers represented through our agency calculate rates based on your driving and claims histories, and in some states your credit based insurance score. Do I have your permission to access these consumer reports?</p>',
          max_length: 100,
          section: '',
          section_type: '',
          sub_section: '',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'CheckBoxFieldRequired',
              rule: '{ "required_checkbox": true, "required": true }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        }, {
          field_name: 'QTE_VEH_0_Vin',
          field_type: 'text_large',
          label: 'VIN',
          field_value: '4M2ZU66K05UJ03226',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 1,
          section_display_order: 0,
          help_text: '<p>Some tips to remember when entering your VIN:\r\n<br>- Your VIN should contain 17 alpha/numeric characters\r\n<br>- The last 5 characters of your VIN should be numeric\r\n<br>- The letters I, O and Q should not appear\r\n<br>- Make sure you don\'t enter the letter l for the number 1 and vice versa\r\n<br>- Make sure you don\'t enter the letter B for the number 8 and vice versa\r\n<br>- Make sure you don\'t enter the letter O for the number 0 and vice versa</p>\r\n<p>If you\'re having trouble entering your VIN, just call one of our licensed insurance agents and they will be happy to help. In some instances, the VIN on your insurance card or vehicle documentation may be incorrect. Our agents can trouble-shoot and try to locate the correct VIN for your vehicle.</p>\r\n<p>You can find your VIN in several locations, including:\r\n<br>- Your current auto insurance card\r\n<br>- The Insurance Declarations Page of your policy\r\n<br>- On your vehicle\'s dashboard, just below the windshield\r\n<br>- On your driver\'s side doorpost\r\n<br>- On your vehicle\'s Title and Registration</p>\r\n<p>Please Note: This definition is intended only as a guideline. All terms and coverages are defined solely by your policy.</p>',
          sub_text: '17 Alphanumeric Characters (Excludes: i,I,o,O,q,Q)',
          placeholder: '',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: true,
          is_required: false,
          script: '',
          max_length: 17,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 00001',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onblur',
              rule_name: 'ValidateVin',
              rule: '',
              rule_url: '/rules/ValidateVin/QTE_VEH_0_Vin',
            },
            {
              rule_type: 'js',
              trigger: 'onblur',
              rule_name: 'OptionalVinFormat',
              rule: '{ "required": false, "length": 17, "regex": "^(?:(?![iIoOqQ])[a-zA-Z0-9-\' ])+$" }',
              rule_url: '',
            },
          ],
          values: [],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_Year',
          field_type: 'select_short',
          label: 'Vehicle Year',
          field_value: '2005',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 2,
          section_display_order: 0,
          help_text: '',
          sub_text: 'Earliest vehicle date is 1981.',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 001',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'GetMakes',
              rule: '',
              rule_url: '/rules/GetMakes/QTE_VEH_0_Year',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'RequiredVehicleYearField',
              rule: '{ "required": true, "date_format": "YYYY", "within_year_date_range": [1981, 2, "YYYY"] }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '2020',
              internal_value: '2020',
              visible: true,
              display_order: 1,
            },
            {
              display_value: '2019',
              internal_value: '2019',
              visible: true,
              display_order: 2,
            },
            {
              display_value: '2018',
              internal_value: '2018',
              visible: true,
              display_order: 3,
            },
            {
              display_value: '2017',
              internal_value: '2017',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '2016',
              internal_value: '2016',
              visible: true,
              display_order: 5,
            },
            {
              display_value: '2015',
              internal_value: '2015',
              visible: true,
              display_order: 6,
            },
            {
              display_value: '2014',
              internal_value: '2014',
              visible: true,
              display_order: 7,
            },
            {
              display_value: '2013',
              internal_value: '2013',
              visible: true,
              display_order: 8,
            },
            {
              display_value: '2012',
              internal_value: '2012',
              visible: true,
              display_order: 9,
            },
            {
              display_value: '2011',
              internal_value: '2011',
              visible: true,
              display_order: 10,
            },
            {
              display_value: '2010',
              internal_value: '2010',
              visible: true,
              display_order: 11,
            },
            {
              display_value: '2009',
              internal_value: '2009',
              visible: true,
              display_order: 12,
            },
            {
              display_value: '2008',
              internal_value: '2008',
              visible: true,
              display_order: 13,
            },
            {
              display_value: '2007',
              internal_value: '2007',
              visible: true,
              display_order: 14,
            },
            {
              display_value: '2006',
              internal_value: '2006',
              visible: true,
              display_order: 15,
            },
            {
              display_value: '2005',
              internal_value: '2005',
              visible: true,
              display_order: 16,
            },
            {
              display_value: '2004',
              internal_value: '2004',
              visible: true,
              display_order: 17,
            },
            {
              display_value: '2003',
              internal_value: '2003',
              visible: true,
              display_order: 18,
            },
            {
              display_value: '2002',
              internal_value: '2002',
              visible: true,
              display_order: 19,
            },
            {
              display_value: '2001',
              internal_value: '2001',
              visible: true,
              display_order: 20,
            },
            {
              display_value: '2000',
              internal_value: '2000',
              visible: true,
              display_order: 21,
            },
            {
              display_value: '1999',
              internal_value: '1999',
              visible: true,
              display_order: 22,
            },
            {
              display_value: '1998',
              internal_value: '1998',
              visible: true,
              display_order: 23,
            },
            {
              display_value: '1997',
              internal_value: '1997',
              visible: true,
              display_order: 24,
            },
            {
              display_value: '1996',
              internal_value: '1996',
              visible: true,
              display_order: 25,
            },
            {
              display_value: '1995',
              internal_value: '1995',
              visible: true,
              display_order: 26,
            },
            {
              display_value: '1994',
              internal_value: '1994',
              visible: true,
              display_order: 27,
            },
            {
              display_value: '1993',
              internal_value: '1993',
              visible: true,
              display_order: 28,
            },
            {
              display_value: '1992',
              internal_value: '1992',
              visible: true,
              display_order: 29,
            },
            {
              display_value: '1991',
              internal_value: '1991',
              visible: true,
              display_order: 30,
            },
            {
              display_value: '1990',
              internal_value: '1990',
              visible: true,
              display_order: 31,
            },
            {
              display_value: '1989',
              internal_value: '1989',
              visible: true,
              display_order: 32,
            },
            {
              display_value: '1988',
              internal_value: '1988',
              visible: true,
              display_order: 33,
            },
            {
              display_value: '1987',
              internal_value: '1987',
              visible: true,
              display_order: 34,
            },
            {
              display_value: '1986',
              internal_value: '1986',
              visible: true,
              display_order: 35,
            },
            {
              display_value: '1985',
              internal_value: '1985',
              visible: true,
              display_order: 36,
            },
            {
              display_value: '1984',
              internal_value: '1984',
              visible: true,
              display_order: 37,
            },
            {
              display_value: '1983',
              internal_value: '1983',
              visible: true,
              display_order: 38,
            },
            {
              display_value: '1982',
              internal_value: '1982',
              visible: true,
              display_order: 39,
            },
            {
              display_value: '1981',
              internal_value: '1981',
              visible: true,
              display_order: 40,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_Make',
          field_type: 'select_medium',
          label: 'Vehicle Make',
          field_value: 'MERCURY',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 3,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 001',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'GetModels',
              rule: '',
              rule_url: '/rules/GetModels/QTE_VEH_0_Make',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: 'ACURA',
              internal_value: 'ACURA',
              visible: true,
              display_order: 0,
            },
            {
              display_value: 'AUDI',
              internal_value: 'AUDI',
              visible: true,
              display_order: 1,
            },
            {
              display_value: 'BMW',
              internal_value: 'BMW',
              visible: true,
              display_order: 2,
            },
            {
              display_value: 'BUICK',
              internal_value: 'BUICK',
              visible: true,
              display_order: 3,
            },
            {
              display_value: 'CADILLAC',
              internal_value: 'CADILLAC',
              visible: true,
              display_order: 4,
            },
            {
              display_value: 'CHEVROLET',
              internal_value: 'CHEVROLET',
              visible: true,
              display_order: 5,
            },
            {
              display_value: 'CHRYSLER',
              internal_value: 'CHRYSLER',
              visible: true,
              display_order: 6,
            },
            {
              display_value: 'DODGE',
              internal_value: 'DODGE',
              visible: true,
              display_order: 7,
            },
            {
              display_value: 'FORD',
              internal_value: 'FORD',
              visible: true,
              display_order: 8,
            },
            {
              display_value: 'GMC',
              internal_value: 'GMC',
              visible: true,
              display_order: 9,
            },
            {
              display_value: 'HONDA',
              internal_value: 'HONDA',
              visible: true,
              display_order: 10,
            },
            {
              display_value: 'HUMMER',
              internal_value: 'HUMMER',
              visible: true,
              display_order: 11,
            },
            {
              display_value: 'HYUNDAI',
              internal_value: 'HYUNDAI',
              visible: true,
              display_order: 12,
            },
            {
              display_value: 'INFINITI',
              internal_value: 'INFINITI',
              visible: true,
              display_order: 13,
            },
            {
              display_value: 'ISUZU',
              internal_value: 'ISUZU',
              visible: true,
              display_order: 14,
            },
            {
              display_value: 'JAGUAR',
              internal_value: 'JAGUAR',
              visible: true,
              display_order: 15,
            },
            {
              display_value: 'JEEP',
              internal_value: 'JEEP',
              visible: true,
              display_order: 16,
            },
            {
              display_value: 'KIA',
              internal_value: 'KIA',
              visible: true,
              display_order: 17,
            },
            {
              display_value: 'LAND ROVER',
              internal_value: 'LAND ROVER',
              visible: true,
              display_order: 18,
            },
            {
              display_value: 'LEXUS',
              internal_value: 'LEXUS',
              visible: true,
              display_order: 19,
            },
            {
              display_value: 'LINCOLN',
              internal_value: 'LINCOLN',
              visible: true,
              display_order: 20,
            },
            {
              display_value: 'MAZDA',
              internal_value: 'MAZDA',
              visible: true,
              display_order: 21,
            },
            {
              display_value: 'MERCEDES-BENZ',
              internal_value: 'MERCEDES-BENZ',
              visible: true,
              display_order: 22,
            },
            {
              display_value: 'MERCURY',
              internal_value: 'MERCURY',
              visible: true,
              display_order: 23,
            },
            {
              display_value: 'MINI',
              internal_value: 'MINI',
              visible: true,
              display_order: 24,
            },
            {
              display_value: 'MITSUBISHI',
              internal_value: 'MITSUBISHI',
              visible: true,
              display_order: 25,
            },
            {
              display_value: 'NISSAN',
              internal_value: 'NISSAN',
              visible: true,
              display_order: 26,
            },
            {
              display_value: 'PONTIAC',
              internal_value: 'PONTIAC',
              visible: true,
              display_order: 27,
            },
            {
              display_value: 'PORSCHE',
              internal_value: 'PORSCHE',
              visible: true,
              display_order: 28,
            },
            {
              display_value: 'SAAB',
              internal_value: 'SAAB',
              visible: true,
              display_order: 29,
            },
            {
              display_value: 'SATURN',
              internal_value: 'SATURN',
              visible: true,
              display_order: 30,
            },
            {
              display_value: 'SPRINTER',
              internal_value: 'SPRINTER',
              visible: true,
              display_order: 31,
            },
            {
              display_value: 'SUBARU',
              internal_value: 'SUBARU',
              visible: true,
              display_order: 32,
            },
            {
              display_value: 'SUZUKI',
              internal_value: 'SUZUKI',
              visible: true,
              display_order: 33,
            },
            {
              display_value: 'TOYOTA',
              internal_value: 'TOYOTA',
              visible: true,
              display_order: 34,
            },
            {
              display_value: 'VOLKSWAGEN',
              internal_value: 'VOLKSWAGEN',
              visible: true,
              display_order: 35,
            },
            {
              display_value: 'VOLVO',
              internal_value: 'VOLVO',
              visible: true,
              display_order: 36,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_Model',
          field_type: 'select_medium',
          label: 'Vehicle Model',
          field_value: 'MOUNTAINEER',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 4,
          section_display_order: 0,
          help_text: '',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: true,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 001',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'GetSubModels',
              rule: '',
              rule_url: '/rules/GetSubModels/QTE_VEH_0_Model',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: 'GRAND MARQUIS GS',
              internal_value: 'GRAND MARQUIS GS',
              visible: true,
              display_order: 0,
            },
            {
              display_value: 'GRAND MARQUIS LS',
              internal_value: 'GRAND MARQUIS LS',
              visible: true,
              display_order: 1,
            },
            {
              display_value: 'MARINER',
              internal_value: 'MARINER',
              visible: true,
              display_order: 2,
            },
            {
              display_value: 'MONTEGO LUXURY',
              internal_value: 'MONTEGO LUXURY',
              visible: true,
              display_order: 3,
            },
            {
              display_value: 'MONTEGO PREMIER',
              internal_value: 'MONTEGO PREMIER',
              visible: true,
              display_order: 4,
            },
            {
              display_value: 'MONTEREY CONVENIENCE',
              internal_value: 'MONTEREY CONVENIENCE',
              visible: true,
              display_order: 5,
            },
            {
              display_value: 'MONTEREY PREMIER',
              internal_value: 'MONTEREY PREMIER',
              visible: true,
              display_order: 6,
            },
            {
              display_value: 'MOUNTAINEER',
              internal_value: 'MOUNTAINEER',
              visible: true,
              display_order: 7,
            },
            {
              display_value: 'SABLE GS',
              internal_value: 'SABLE GS',
              visible: true,
              display_order: 8,
            },
            {
              display_value: 'SABLE LS PREMIUM',
              internal_value: 'SABLE LS PREMIUM',
              visible: true,
              display_order: 9,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 002',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 006',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 005',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 004',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 003',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
        {
          field_name: 'QTE_VEH_0_SubModel',
          field_type: 'select_medium',
          label: 'Vehicle Submodel',
          field_value: '4.0L V6/4x2',
          group_id: 3,
          index: 0,
          sub_index: null,
          display_order: 5,
          section_display_order: 0,
          help_text: 'The submodel refers to vehicle specifics such as engine and/or drivetrain details.',
          sub_text: '',
          placeholder: '-Select One-',
          visible: true,
          is_quote_summary_field: false,
          is_enabled: false,
          is_required: true,
          script: '',
          max_length: 100,
          section: 'Previous Claims',
          section_type: 'Accordion',
          sub_section: 'Claim 003',
          sub_section_type: '',
          sub_index_section: '',
          sub_index_section_type: '',
          rules: [
            {
              rule_type: 'api',
              trigger: 'onchange',
              rule_name: 'ManageSubModelDependentFields',
              rule: '',
              rule_url: '/rules/ManageSubModelDependentFields/QTE_VEH_0_SubModel',
            },
            {
              rule_type: 'js',
              trigger: 'onchange',
              rule_name: 'FieldRequired',
              rule: '{ "required": true }',
              rule_url: '',
            },
          ],
          values: [
            {
              display_value: '4.6L V8/4x2',
              internal_value: '4.6L V8/4x2',
              visible: true,
              display_order: 4,
            },
            {
              display_value: '4.6L V8/4x4',
              internal_value: '4.6L V8/4x4',
              visible: true,
              display_order: 5,
            },
          ],
          has_error: false,
          error: null,
        },
      ],
      blurbs: [
        {
          location: 'helptext',
          content: 'This is the super unknown help text.',
          visible: true,
        }, {
          location: 'formtop',
          content: 'Here we are now at the top of form. Let\'s go for a ride.',
          visible: true,
        }, {
          location: 'formbottom',
          content: 'If there is text at the bottom of this form, then this is what it is right here.',
          visible: true,
        },
      ],
      Error: null,
      quote_summary: {
        quote_status: 'Rate1',
        quote_summary_sections: [
          {
            label: 'Named Insured',
            content: [
              {
                fields: [
                  {
                    label: 'Name',
                    field_value: 'Melissa Desmarais',
                  }, {
                    label: 'Address',
                    field_value: '2160 Southwest 85th Avenue  North Lauderdale, FL 33068',
                  }, {
                    label: 'Email',
                    field_value: 'polk-test@email.com',
                  }, {
                    label: 'Phone',
                    field_value: '2424242424',
                  },
                ],
              },
            ],
          },
          {
            label: 'Vehicle(s)',
            content: [
              {
                fields: [
                  {
                    label: 'Vehicle',
                    field_value: '2011 BMW M3',
                  }, {
                    label: 'VIN',
                    field_value: 'WBSPM9C52BE202514',
                  }, {
                    label: 'Ownership',
                    field_value: 'Financed',
                  },
                  {
                    label: 'Annual Mileage',
                    field_value: '6700',
                  },
                ],
              },
            ],
          },
        ],
      },
    },
};

export default fallbackData;



//////////////////
// WEBPACK FOOTER
// ./config/admin/fallbackData.js
// module id = null
// module chunks = 